import React from 'react';
import Button from 'component/button.component';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Termos({ onClickAgreeTerms, closeModal }) {
  return (
    <div className="container">
      <Helmet>
        <title>Termos de uso da plataforma Juslabore</title>
        <meta name="description" content="Termos de uso da plataforma Juslabore" />
      </Helmet>
      <h1 style={{ textAlign: 'center' }}>Termos de Uso da Aplicação</h1>
      <ol>
        {' '}
        <li>
          <strong>INTRODU&Ccedil;&Atilde;O</strong>
        </li>
      </ol>
      <p>
        O aceite destes Termos de Uso configura uma licen&ccedil;a de uso
        n&atilde;o exclusiva das ferramentas tecnol&oacute;gicas contidas na
        PLATAFORMA JUSLABORE aos USU&Aacute;RIOS. As ferramentas
        tecnol&oacute;gicas s&atilde;o licenciadas no estado em que se
        encontram, podendo ser modificadas, substitu&iacute;das ou removidas da
        PLATAFORMA JUSLABORE a qualquer momento, sem aviso pr&eacute;vio. O
        respeito &agrave;s condi&ccedil;&otilde;es destes Termos de Uso &eacute;
        essencial para o uso leg&iacute;timo de tais ferramentas.
      </p>
      <p>
        O USU&Aacute;RIO expressamente declara que tem conhecimento e concorda
        com os Termos de Uso da PLATAFORMA JUSLABORE, inclusive com as
        Pol&iacute;ticas de Privacidade e de Direitos Autorais que, apesar de
        apresentadas em textos separados, s&atilde;o parte integrante destes. O
        uso das ferramentas tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE
        em discord&acirc;ncia com os termos a seguir poder&aacute; implicar a
        suspens&atilde;o do acesso &agrave; conta ou o cancelamento do cadastro
        do USU&Aacute;RIO, o consequente e imediato encerramento da
        licen&ccedil;a de uso previamente existente e eventuais outras
        san&ccedil;&otilde;es, conforme adiante detalhado.
      </p>
      <ol start="2">
        <li>
          <strong>
            PROVEDORA DAS FERRAMENTAS TECNOL&Oacute;GICAS E PRESTADORA DE
            SERVI&Ccedil;OS
          </strong>
        </li>
      </ol>
      <p>
        As ferramentas tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE
        s&atilde;o disponibilizadas pela JUSLABORE Tecnologia Ltda, pessoa
        jur&iacute;dica de direito privado, sediada na Avenida Capit&atilde;o
        Manoel Caetano, 412 sala 4, Centro, 08710-190-Mogi das Cruzes/SP, para
        serem utilizadas em transa&ccedil;&otilde;es realizadas no Brasil, em
        reais.
      </p>
      <ol start="3">
        <li>
          <strong>DEFINI&Ccedil;&Otilde;ES</strong>
        </li>
        <p>
          Sempre que as expressões abaixo forem usadas em letra maiúscula nestes
          Termos de Uso, elas terão o significado abaixo:
        </p>
        <ol type="a">
          <li><strong>PLATAFORMA JUSLABORE ou JUSLABORE</strong> – Plataforma
          “online” que se destina a aproximar PRODUTORES, AFILIADOS e potenciais
          COMPRADORES interessados nos CONTEÚDOS divulgados por meio das
          ferramentas tecnológicas contidas na plataforma. A PLATAFORMA JUSLABORE
          poderá comercializar/disponibilizar CONTEÚDO próprio, de PRODUTOR,
          CO-PRODUTOR e AFILIADO;</li>
          <li><strong>CONTEÚDO</strong> – conteúdo em diversos formatos digitais (vídeo,
          áudio, texto, software etc), também denominado PRODUTO DIGITAL, criado
          pelo PRODUTOR ou por terceiro de quem o PRODUTOR tenha recebido
          autorização em caráter de exclusividade para exploração comercial e que
          é disponibilizado pelo PRODUTOR para divulgação, promoção e
          comercialização mediante o uso das ferramentas tecnológicas contidas na
          PLATAFORMA JUSLABORE;</li>
          <li><strong>USUÁRIO</strong> – qualquer pessoa natural ou fictícia (por
          quem a represente) que acesse a PLATAFORMA JUSLABORE, independentemente
          do fato de ter feito ou não o seu cadastro como PRODUTOR, AFILIADO ou
          COMPRADOR;</li>
          <li><strong>PRODUTOR</strong> – USUÁRIO titular de direitos de propriedade
          intelectual de CONTEÚDO ou detentor de autorização válida para exploração
          comercial em caráter de exclusividade do CONTEÚDO e que utiliza as
          ferramentas tecnológicas contidas na PLATAFORMA JUSLABORE para viabilizar
          a divulgação, a promoção e a comercialização de tal CONTEÚDO. Também
          serão considerados como PRODUTOR aqueles USUÁRIOS que atuem em parceria
          com outro PRODUTOR para o lançamento, divulgação e comercialização
          conjunta de PRODUTOS DIGITAIS. Neste caso, denominado CO-PRODUTOR, que
          observará integralmente os presentes Termos de Uso e Políticas da
          JUSLABORE, além das regras e termos de CO-PRODUÇÃO aceitos por PRODUTOR
          e CO-PRODUTOR no momento da constituição da parceria na PLATAFORMA;
          <br></br></li>
          <li><strong>AFILIADO</strong> – USUÁRIO que se cadastra no programa
          JUSLABORE de promoção de CONTEÚDO, e, mediante o uso das ferramentas
          tecnológicas contidas na PLATAFORMA JUSLABORE, divulga CONTEÚDO
          disponibilizado por determinado PRODUTOR, em sites, blogs, páginas e
          comunidades em redes sociais etc, e recebe remuneração se alguma
          negociação for concretizada em razão de suas ações promocionais
          conforme registro identificador desse AFILIADO nas ferramentas
          tecnológicas de rastreamento da PLATAFORMA JUSLABORE;</li>
          <li><strong>COMPRADOR</strong> – USUÁRIO que adquire CONTEÚDO mediante
          o uso das ferramentas tecnológicas disponibilizadas pela PLATAFORMA
          JUSLABORE;</li>

          <li><strong>JUSLABORE CLUB</strong> – Funcionalidade opcional que
          permite ao PRODUTOR criar dentro da PLATAFORMA JUSLABORE uma Área
          de Membros de acesso restrito e controlada por “login” e senha
          fornecidos ao COMPRADOR para disponibilização de CONTEÚDO tanto
          mediante “download” quanto “streaming” por parte do COMPRADOR.</li>
        </ol>
      </ol>
      <ol start="4">
        <li>
          <strong>
            FINALIDADE DAS FERRAMENTAS TECNOL&Oacute;GICAS E SERVI&Ccedil;OS
            PRESTADOS
          </strong>
        </li>
      </ol>
      <p>
        As ferramentas tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE
        permitir&aacute; que PRODUTORES divulguem, promovam e comercializem seu
        CONTE&Uacute;DO sem precisar desenvolver uma plataforma
        &ldquo;online&rdquo; pr&oacute;pria, bem como que AFILIADOS sejam
        identificados como os intermediadores de determinada
        transa&ccedil;&atilde;o de compra e venda e recebam a respectiva
        remunera&ccedil;&atilde;o.
      </p>
      <p>
        O PRODUTOR poder&aacute; contar com ferramentas tecnol&oacute;gicas para
        automatiza&ccedil;&atilde;o da entrega de CONTE&Uacute;DO, tais como:
      </p>
      <ol type='a'>
        <li>
          &Aacute;rea de Membros (pela qual o PRODUTOR pode controlar o acesso
          de seus clientes aos CONTE&Uacute;DOS disponibilizados);
        </li>
        <li>
          Funil de Vendas (pelo qual h&aacute; a possibilidade de
          cria&ccedil;&atilde;o de p&aacute;ginas de captura, p&aacute;ginas de
          vendas e outras a&ccedil;&otilde;es que chamem a aten&ccedil;&atilde;o
          do COMPRADOR);
        </li>
        <li>
          &ldquo;checkout&rdquo; (pelo qual a transa&ccedil;&atilde;o de compra
          e venda pode ser efetivamente realizada);
        </li>
        <li>
          Cupons Promocionais (pelos quais o PRODUTOR pode criar links de
          compras com novos valores de acordo com sua estrat&eacute;gia de
          vendas, permitindo a realiza&ccedil;&atilde;o de
          promo&ccedil;&otilde;es tempor&aacute;rias).
        </li>
      </ol>
      <p>
        O AFILIADO poder&aacute; contar com ferramentas tecnol&oacute;gicas que
        fazem o rastreamento das suas indica&ccedil;&otilde;es de vendas e
        ajudam a gerenciar o resultado de sua atua&ccedil;&atilde;o na
        promo&ccedil;&atilde;o de CONTE&Uacute;DO, tais como:
      </p>
      <ol type='a'>
        <li>
          Cookies (com dura&ccedil;&atilde;o m&iacute;nima de 60 dias);&nbsp;
        </li>
        <li>
          Hotleads (ferramenta exclusiva da JUSLABORE que combina v&aacute;rios
          m&eacute;todos diferentes no processo de verifica&ccedil;&atilde;o da
          identifica&ccedil;&atilde;o do AFILIADO);
        </li>
        <li>
          p&aacute;ginas alternativas din&acirc;micas (pelas quais o AFILIADO
          consegue usar conte&uacute;dos relevantes para cria&ccedil;&atilde;o
          de&nbsp;links&nbsp;para venda, aumentando sua capacidade de atrair
          COMPRADORES);
        </li>
        <li>
          pixel tracking (pela qual o AFILIADO pode acompanhar as
          convers&otilde;es de seus an&uacute;ncios no Facebook Ads)
          e&nbsp;relat&oacute;rios&nbsp;com a indica&ccedil;&atilde;o da origem
          de clicks e de vendas.
        </li>
      </ol>
      <p>
        A PLATAFORMA JUSLABORE poder&aacute; disponibilizar ainda ferramentas
        para recebimento de remunera&ccedil;&atilde;o por seus respectivos
        USU&Aacute;RIOS, as quais permitem que sejam gerados cr&eacute;ditos
        para os usu&aacute;rios decorrentes da comercializa&ccedil;&atilde;o de
        PRODUTOS, conforme detalhado no item GEST&Atilde;O DE PAGAMENTOS.
      </p>
      <p>
        Em aten&ccedil;&atilde;o a diretrizes expedidas por &oacute;rg&atilde;os
        de alcance internacional, como Office of Foreign Assets Control (OFAC),
        a PLATAFORMA JUSLABORE n&atilde;o transaciona e/ou opera com
        usu&aacute;rios localizados em determinados pa&iacute;ses ou
        regi&otilde;es, em atendimento as normas e boas pr&aacute;ticas globais
        voltadas &agrave; preven&ccedil;&atilde;o da lavagem de dinheiro, atos
        fraudulentos e financiamento de atividades il&iacute;citas.
      </p>
      <ol start="5">
        <li>
          <strong>CADASTRO, LOGIN, SENHA E SEGURAN&Ccedil;A</strong>
        </li>
      </ol>
      <p>
        &Agrave; exce&ccedil;&atilde;o das pessoas fict&iacute;cias, os
        servi&ccedil;os oferecidos pela JUSLABORE somente podem ser contratados
        por pessoa natural habilitada &agrave; pr&aacute;tica de todos os atos
        da vida civil (maiores de 18 anos, ou regularmente emancipados), sendo
        vedado o cadastro de pessoas naturais menores de idade.
      </p>
      <p>
        Ao utilizar a PLATAFORMA JUSLABORE, o USU&Aacute;RIO, pessoa natural,
        declara ser maior de 18 anos e estar em plena capacidade do
        exerc&iacute;cio de todos os atos da vida civil.
      </p>
      <p>
        Para utiliza&ccedil;&atilde;o da PLATAFORMA JUSLABORE, o USU&Aacute;RIO
        obriga-se a preencher adequadamente e com informa&ccedil;&otilde;es
        corretas todos os dados solicitados pelo JUSLABORE na p&aacute;gina de
        cadastramento do site.
      </p>
      <p>
        A JUSLABORE reserva-se o direito de n&atilde;o aprovar o cadastro do
        USU&Aacute;RIO, se houver ind&iacute;cio de que este utilizar&aacute; a
        PLATAFORMA JUSLABORE em desacordo com estes Termos de Uso.
      </p>
      <p>
        A JUSLABORE poder&aacute; usar quaisquer meios v&aacute;lidos para
        identifica&ccedil;&atilde;o dos USU&Aacute;RIOS e ainda requerer a
        qualquer momento dados adicionais para complementar aqueles j&aacute;
        fornecidos. Caso o USU&Aacute;RIO envie informa&ccedil;&otilde;es
        incorretas ou incompletas, o cadastro na PLATAFORMA JUSLABORE
        poder&aacute; ser cancelado ou suspenso temporariamente.
      </p>
      <p>
        O USU&Aacute;RIO ser&aacute; o &uacute;nico respons&aacute;vel por
        seu&nbsp;login&nbsp;e senha e responder&aacute; por todos os atos
        praticados com estes. Portanto, &eacute; dever do USU&Aacute;RIO zelar
        pela guarda e confidencialidade de sua senha. A JUSLABORE n&atilde;o
        &eacute; respons&aacute;vel por qualquer perda resultante do uso
        indevido da senha do USU&Aacute;RIO por terceiros.
      </p>
      <p>
        O USU&Aacute;RIO concorda que&nbsp;os dados fornecidos no momento do
        cadastro&nbsp;na PLATAFORMA JUSLABORE poder&atilde;o ser entregues ao
        COMPRADOR, AFILIADO, ou PRODUTOR, em caso de: infra&ccedil;&atilde;o
        destes Termos de Uso que possa provocar danos a outros USU&Aacute;RIOS
        da Plataforma ou a terceiros; suspeita de fraude; disputa;
        reclama&ccedil;&atilde;o quanto ao produto comercializado ou qualquer
        ind&iacute;cio de il&iacute;cito cometido pelo USU&Aacute;RIO, quando
        necess&aacute;rio para o cumprimento de obriga&ccedil;&otilde;es
        contratuais firmada entre as partes (JUSLABORE, USU&Aacute;RIOS e
        COMPRADORES), em caso de interesse leg&iacute;timo e para atendimento a
        legisla&ccedil;&atilde;o aplic&aacute;vel, especialmente de cunho fiscal
        e tribut&aacute;rio, conforme detalhado na Pol&iacute;tica de
        Privacidade.
      </p>
      <p>
        Ap&oacute;s realizar a primeira venda por meio da PLATAFORMA JUSLABORE,
        os PRODUTORES e AFILIADOS dever&atilde;o fornecer dados
        banc&aacute;rios, indicando uma conta banc&aacute;ria de sua
        titularidade, para receber o valor das transa&ccedil;&otilde;es
        efetivadas por meio das ferramentas contidas na PLATAFORMA JUSLABORE.
        N&atilde;o ser&aacute; permitido o cadastro e/ou o repasse de valores
        devidos aos USU&Aacute;RIOS para conta banc&aacute;ria de terceiros, por
        interm&eacute;dio da PLATAFORMA JUSLABORE. N&atilde;o ser&aacute;
        permitido o cadastro e/ou o repasse de valores devidos aos
        USU&Aacute;RIOS para conta banc&aacute;ria de terceiros, utilizando a
        PLATAFORMA JUSLABORE.
      </p>
      <p>
        Al&eacute;m disso, ser&aacute; vedado aos USU&Aacute;RIOS cadastrados
        como pessoa natural cadastrarem conta banc&aacute;ria localizada em um
        pa&iacute;s diferente do Brasil.
      </p>
      <p>
        O USU&Aacute;RIO &eacute; respons&aacute;vel pela veracidade e
        assertividade dos dados cadastrados, respondendo por desdobramentos
        decorrentes da incorre&ccedil;&atilde;o dos dados e
        informa&ccedil;&otilde;es fornecidos no ato de cadastramento. A
        t&iacute;tulo exemplificativo, ao cadastrar equivocadamente seu e-mail,
        o USU&Aacute;RIO pode deixar de receber informa&ccedil;&otilde;es
        relevantes sobre a PLATAFORMA JUSLABORE ou at&eacute; mesmo sobre o
        acesso aos conte&uacute;dos adquiridos. Assim, &eacute; essencial que o
        USU&Aacute;RIO mantenha seu cadastro atualizado e revise seus dados a
        cada 6 (seis) meses a contar do seu cadastramento ou
        realiza&ccedil;&atilde;o de uma compra.
      </p>
      <ol start="6">
        <li>
          <strong>
            REGRAS PARA A INCLUS&Atilde;O DE CONTE&Uacute;DO NA PLATAFORMA
            JUSLABORE POR PRODUTOR
          </strong>
        </li>
      </ol>
      <p>
        O USU&Aacute;RIO poder&aacute; usar as ferramentas contidas na
        PLATAFORMA JUSLABORE para comercializar seu CONTE&Uacute;DO diretamente
        ou para disponibiliz&aacute;-lo para divulga&ccedil;&atilde;o e
        promo&ccedil;&atilde;o.
      </p>
      <p>Para tanto, o USU&Aacute;RIO dever&aacute;:</p>
      <ol type='a'>
        <li>
          registrar-se na PLATAFORMA JUSLABORE como um PRODUTOR,
          responsabilizando-se pelo uso apropriado das ferramentas contidas na
          PLATAFORMA JUSLABORE, bem como, em caso de d&uacute;vidas, buscar o
          esclarecimento necess&aacute;rio nos canais dispon&iacute;veis na
          PLATAFORMA JUSLABORE;
        </li>
        <li>
          aceitar e respeitar os Termos de Uso e Pol&iacute;ticas da JUSLABORE;
        </li>
        <li>
          ser o autor ou ter autoriza&ccedil;&atilde;o do titular de direitos
          autorais sobre o CONTE&Uacute;DO, ou para promov&ecirc;-lo e
          comercializ&aacute;-lo em car&aacute;ter de exclusividade,
          responsabilizando-se por n&atilde;o conceder autoriza&ccedil;&atilde;o
          a terceiros para que explorem o CONTE&Uacute;DO concorrentemente;
        </li>
        <li>
          respeitar todas as indica&ccedil;&otilde;es de CONTE&Uacute;DO
          PROIBIDO contidas nestes Termos de Uso, abstendo-se de tentar inserir
          na PLATAFORMA JUSLABORE CONTE&Uacute;DO PROIBIDO, reconhecendo ser o
          &uacute;nico respons&aacute;vel pelo CONTE&Uacute;DO que incluir na
          PLATAFORMA JUSLABORE;
        </li>
        <li>
          incluir o CONTE&Uacute;DO na PLATAFORMA JUSLABORE fornecendo todas as
          informa&ccedil;&otilde;es solicitadas a seu respeito (inclusive dados
          banc&aacute;rios); a respeito do pre&ccedil;o de oferta do
          CONTE&Uacute;DO e das formas de pagamento; das regras de
          aceita&ccedil;&atilde;o e comiss&atilde;o dos AFILIADOS (percentual e
          possibilidade de recebimento pela primeira indica&ccedil;&atilde;o,
          pela &uacute;ltima indica&ccedil;&atilde;o ou de divis&atilde;o da
          comiss&atilde;o para a primeira e &uacute;ltima
          indica&ccedil;&otilde;es) e do prazo de garantia (15 dias), podendo
          alterar tais informa&ccedil;&otilde;es a qualquer momento, sem
          necessidade de aviso pr&eacute;vio, mas responsabilizando-se perante
          AFILIADOS e COMPRADORES a respeitar as informa&ccedil;&otilde;es ali
          constantes no ato de cada opera&ccedil;&atilde;o realizada;
        </li>
        <li>
          aguardar o per&iacute;odo necess&aacute;rio para que o CONTE&Uacute;DO
          fique dispon&iacute;vel para divulga&ccedil;&atilde;o e
          comercializa&ccedil;&atilde;o na PLATAFORMA JUSLABORE, eis que o
          CONTE&Uacute;DO poder&aacute; passar por uma an&aacute;lise de
          conformidade com estes Termos de Uso, e se n&atilde;o estiver de
          acordo com estes Termos de Uso n&atilde;o ser&aacute; divulgado;
        </li>
        <li>
          abster-se de comercializar o CONTE&Uacute;DO por qualquer outro meio
          que n&atilde;o a PLATAFORMA JUSLABORE;
        </li>
        <li>
          utilizar, exclusivamente, as ferramentas e solu&ccedil;&otilde;es de
          pagamento fornecidas pela PLATAFORMA JUSLABORE;
        </li>
        <li>
          aceitar, segundo seus crit&eacute;rios, os pedidos de
          afilia&ccedil;&atilde;o para seu CONTE&Uacute;DO, comprometendo-se
          &agrave; comercializa&ccedil;&atilde;o do CONTE&Uacute;DO e ao
          pagamento da comiss&atilde;o devida pela divulga&ccedil;&atilde;o
          promovida pelos AFILIADOS exclusivamente pelos instrumentos
          disponibilizados na PLATAFORMA JUSLABORE;
        </li>
        <li>
          cumprir as regras de comiss&atilde;o devidas a AFILIADOS que tenham
          realizado a promo&ccedil;&atilde;o e venda do CONTE&Uacute;DO,
          comunicando aos AFILIADOS com anteced&ecirc;ncia de 30 (trinta) dias
          caso decida cancelar o programa de afilia&ccedil;&atilde;o para o
          CONTE&Uacute;DO;
        </li>
        <li>
          responsabilizar-se diretamente perante os AFILIADOS que se sintam
          prejudicados pelo n&atilde;o recebimento de comiss&otilde;es em
          raz&atilde;o do uso de meios fraudulentos que levem &agrave;
          desconsidera&ccedil;&atilde;o do sistema de rastreamento da JUSLABORE;
        </li>
        <li>
          responsabilizar-se por prestar informa&ccedil;&otilde;es claras e
          objetivas sobre o CONTE&Uacute;DO ofertado por meio das ferramentas
          contidas na PLATAFORMA JUSLABORE; mantendo-as atualizadas e
          compat&iacute;veis com aquelas divulgadas em seus
          &ldquo;websites&rdquo;, p&aacute;ginas de vendas e &aacute;reas de
          membros externas &agrave; PLATAFORMA JUSLABORE, dentre outra, bem como
          responsabilizar-se perante o COMPRADOR e JUSLABORE por eventuais
          diverg&ecirc;ncias, especialmente no tocante aos pre&ccedil;os do
          CONTE&Uacute;DO, sua qualidade, descri&ccedil;&atilde;o,
          adequa&ccedil;&atilde;o ao objetivo a que se prop&otilde;e e aos
          prazos de garantia, entrega em caso de n&atilde;o
          atualiza&ccedil;&atilde;o;
        </li>
        <li>
          responsabilizar-se pela entrega do CONTE&Uacute;DO ao COMPRADOR,
          especialmente se realizado por meio de &ldquo;posts&rdquo; e
          &aacute;reas de membros externos &agrave; PLATAFORMA JUSLABORE, bem
          como por garantir que o COMPRADOR possa utilizar o CONTE&Uacute;DO da
          maneira como foi ofertado; responsabilizar-se pelo cumprimento
          integral de todas as obriga&ccedil;&otilde;es legais relacionadas
          &agrave;s vendas realizadas com o uso das ferramentas contidas na
          PLATAFORMA JUSLABORE;
        </li>
        <li>
          respeitar o prazo de garantia que tiver indicado no cadastro do
          CONTE&Uacute;DO, que n&atilde;o poder&aacute; ser inferior &agrave; 15
          dias, na PLATAFORMA JUSLABORE, comprometendo-se a aceitar eventual
          solicita&ccedil;&atilde;o de cancelamento da venda por parte da
          JUSLABORE, autorizando, desde j&aacute;, que a JUSLABORE realize a
          dedu&ccedil;&atilde;o dos valores objeto de reembolso dos
          cr&eacute;ditos existentes em sua conta;
        </li>
        <li>
          responsabilizar-se por solucionar quaisquer problemas, em especial de
          origem t&eacute;cnica, que ocorrerem com o CONTE&Uacute;DO ap&oacute;s
          a entrega ao COMPRADOR, assumindo a obriga&ccedil;&atilde;o de
          fornecer suporte adequado ao COMPRADOR sempre que solicitado pela
          JUSLABORE, bem como responder aos eventuais contatos da equipe de
          suporte da PLATAFORMA JUSLABORE viabilizando o adequado atendimento
          aos USU&Aacute;RIOS;
        </li>
        <li>
          responsabilizar-se por alterar sempre que necess&aacute;rio as
          informa&ccedil;&otilde;es relativas ao CONTE&Uacute;DO, assim como por
          suspender ou cancelar sua divulga&ccedil;&atilde;o sempre que deixar
          de atender a qualquer das condi&ccedil;&otilde;es destes Termos de
          Uso, sem preju&iacute;zo de permanecer respons&aacute;vel por todas as
          obriga&ccedil;&otilde;es decorrentes do per&iacute;odo de
          divulga&ccedil;&atilde;o;
        </li>
        <li>
          arcar com as tarifas decorrentes do uso das ferramentas
          tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE e arcar com suas
          obriga&ccedil;&otilde;es legais, regulat&oacute;rias, fiscais,
          trabalhistas e tribut&aacute;rias, se, quando e onde existentes;
        </li>
        <li>
          ceder &agrave; JUSLABORE, no momento da opera&ccedil;&atilde;o,
          autoriza&ccedil;&atilde;o relativa aos direitos autorais e de
          propriedade intelectual relativos ao CONTE&Uacute;DO para todos os
          fins e efeitos legais, em car&aacute;ter irrevog&aacute;vel,
          irretrat&aacute;vel e n&atilde;o exclusivo, pelo prazo que o
          CONTE&Uacute;DO estiver cadastrado na PLATAFORMA JUSLABORE,
          exclusivamente com o objetivo de permitir que a JUSLABORE revenda
          regularmente o CONTE&Uacute;DO. Nesse sentido, a referida
          cess&atilde;o de direitos autorais pelo PRODUTOR &agrave; JUSLABORE
          n&atilde;o significa, em qualquer aspecto, que o CONTE&Uacute;DO e os
          direitos a ele associados passam a pertencer &agrave; JUSLABORE, mas
          somente que a JUSLABORE est&aacute; autorizada a revender o
          CONTE&Uacute;DO, sendo que o PRODUTOR continua sendo detentor de todos
          os direitos e obriga&ccedil;&otilde;es relacionadas ao CONTE&Uacute;DO
          comercializado na PLATAFORMA JUSLABORE. Ademais, a cess&atilde;o de
          direitos autorias de que trata esse item &eacute; aplic&aacute;vel
          apenas &agrave;s opera&ccedil;&otilde;es realizadas a partir das
          ferramentas disponibilizadas pela JUSLABORE;
        </li>
        <li>
          aceitar e respeitar, todas as pol&iacute;ticas da PLATAFORMA
          JUSLABORE, em especial o Termo de Compra e de Pol&iacute;ticas de
          Cookies e Ferramentas de Coleta Autom&aacute;tica de Dados,
          reconhecendo neste ato que, ao se cadastrar na PLATAFORMA JUSLABORE,
          tomou conhecimento de tais documentos, que est&atilde;o devidamente
          publicados no site da JUSLABORE (
          <a href="http://www.hotmart.com/">
            <strong>juslabore.com.br</strong>
          </a>
          ), se sujeitando e se comprometendo a observar todas as regras,
          princ&iacute;pios e diretrizes neles previstos;
        </li>
        <li>
          responsabilizar-se, integralmente, por cumprir as leis e normativos
          aplic&aacute;veis relativos a prote&ccedil;&atilde;o de dados
          pessoais, em especial o Lei Geral de Prote&ccedil;&atilde;o de Dados
          Pessoais ou &ldquo;LGPD&rdquo; - (LEI N&ordm; 13.709, DE 14 DE AGOSTO
          DE 2018), assumindo a obriga&ccedil;&atilde;o de obter o consentimento
          expresso e inequ&iacute;voco de seus usu&aacute;rios relativamente a
          coleta, armazenamento, tratamento e processamento de dados pessoais,
          nos termos da legisla&ccedil;&atilde;o aplic&aacute;vel;
        </li>
        <li>
          reconhecer que &eacute; inteira e exclusivamente respons&aacute;vel
          pelo CONTE&Uacute;DO ofertado na PLATAFORMA JUSLABORE, incluindo, mas
          n&atilde;o se limitando, as informa&ccedil;&otilde;es,
          caracter&iacute;sticas, qualidades, quantidade,
          descri&ccedil;&atilde;o, adequa&ccedil;&atilde;o do conte&uacute;do ao
          objetivo proposto, composi&ccedil;&atilde;o, pre&ccedil;o, garantia,
          prazos de validade e entrega. Nesse sentido, caso a JUSLABORE venha a
          responder, por meio de seu suporte, administrativa ou judicialmente
          pelo CONTE&Uacute;DO gerado pelos PRODUTOR, os valores despendidos
          poder&atilde;o, a seu crit&eacute;rio exclusivo, ser abatido das
          comiss&otilde;es, saldos contratuais e demais valores devidos ao
          PRODUTOR respons&aacute;vel at&eacute; o limite necess&aacute;rio
          &agrave; recomposi&ccedil;&atilde;o dos custos dispendidos pela
          JUSLABORE em raz&atilde;o de a&ccedil;&otilde;es, acordos
          extrajudiciais e judiciais firmados com terceiros em raz&atilde;o de
          falhas do CONTE&Uacute;DO gerado pelo PRODUTOR, bem como
          condena&ccedil;&otilde;es judiciais. Assim, o PRODUTOR concorda e
          autoriza, desde j&aacute;, a reten&ccedil;&atilde;o e/ou
          cobran&ccedil;a dos referidos valores, pela JUSLABORE, nos termos do
          art. 784, inciso III, da LEI N&ordm; 13.105 de 16 DE MAR&Ccedil;O DE
          2015.
        </li>
      </ol>
      <ol start='7'>
        <li>
          <strong>CONTE&Uacute;DOS PROIBIDOS</strong>
        </li>
      </ol>
      <p>
        &Eacute; expressamente proibido o an&uacute;ncio ou a
        comercializa&ccedil;&atilde;o por meio da PLATAFORMA JUSLABORE dos
        seguintes CONTE&Uacute;DOS:
      </p>
      <ol type='a'>
        <li>
          produtos que fa&ccedil;am alus&atilde;o a armas de fogo,
          narc&oacute;ticos, t&oacute;xicos e qualquer tipo de drogas ilegais,
          bem como a qualquer subst&acirc;ncia il&iacute;cita e/ou que dependa,
          necessariamente, de prescri&ccedil;&atilde;o m&eacute;dica para seu
          consumo;
        </li>
        <li>produtos subtra&iacute;dos de terceiros, furtados ou roubados;</li>
        <li>produtos falsificados ou adulterados;</li>
        <li>a&ccedil;&otilde;es de empresas negociadas em Bolsa de Valores;</li>
        <li>listas de correio ou bases de dados pessoais;</li>
        <li>
          produtos que violem a intimidade, a honra, a imagem, o nome ou
          qualquer outro direito de personalidade de terceiros;
        </li>
        <li>
          produtos relacionados &agrave; pedofilia, &agrave;
          prostitui&ccedil;&atilde;o ou similares, material pornogr&aacute;fico,
          contendo cenas de nudez ou atos sexuais, ou de algum modo obsceno ou
          contr&aacute;rio a moral e os bons costumes;
        </li>
        <li>produtos que fa&ccedil;am apologia do h&aacute;bito de fumar;</li>
        <li>
          produtos que promovam esquemas de pir&acirc;mide, marketing
          multin&iacute;vel ou esquemas similares cujo funcionamento dependa,
          prioritariamente, de recursos financeiros aportados por novos
          participantes para remunerar participantes anteriores, de forma
          insustent&aacute;vel, gerando preju&iacute;zos aos participantes que
          entram por &uacute;ltimo;
        </li>
        <li>
          produtos que prometam sucesso em loterias, jogos de azar, bem como
          qualquer atividade ou pr&aacute;tica que dependa de fatores
          relacionados sorte para seu sucesso;
        </li>
        <li>
          produtos que promovam a viol&ecirc;ncia e/ou a
          discrimina&ccedil;&atilde;o baseada em quest&otilde;es de ra&ccedil;a,
          sexo, religi&atilde;o, nacionalidade, orienta&ccedil;&atilde;o sexual
          ou de qualquer outro tipo de discrimina&ccedil;&atilde;o;
        </li>
        <li>
          produtos que prometem o atingimento de qualquer tipo de resultado,
          seja de natureza f&iacute;sica, mental ou de outra esp&eacute;cie, sem
          respaldo cient&iacute;fico robusto e/ou reconhecimento pelos
          &oacute;rg&atilde;os e entidades competentes;
        </li>
        <li>
          produtos que contenham m&uacute;sicas, imagens e v&iacute;deos em
          quaisquer formatos, quando os mesmos n&atilde;o est&atilde;o
          expressamente autorizados pelo titular dos direitos autorais;
        </li>
        <li>
          produtos que violem direitos intelectuais de terceiros, tais como
          produtos que violem software, direitos autorais, patentes, marcas,
          modelos e desenhos industriais, especialmente produtos que contenham
          software para OEM, NFR, c&oacute;pias e/ou arquivos de
          &ldquo;backup&rdquo;, licen&ccedil;a, programas acad&ecirc;micos e/ou
          desenvolvidos para alguma entidade educacional, ou segredos
          industriais;
        </li>
        <li>
          produtos afetados por alguma restri&ccedil;&atilde;o de qualquer
          esp&eacute;cie quanto ao seu uso, explora&ccedil;&atilde;o ou
          transfer&ecirc;ncia de dom&iacute;nio ou posse;
        </li>
        <li>
          produtos que n&atilde;o apresentem, claramente, em sua oferta e
          divulga&ccedil;&atilde;o, as disposi&ccedil;&otilde;es relacionadas a
          sua forma de aquisi&ccedil;&atilde;o e consumo, pre&ccedil;o, contato
          de suporte, regras de reembolso, cancelamento, garantias,
          renova&ccedil;&atilde;o, dentre outras informa&ccedil;&otilde;es
          exigidas por lei;
        </li>
        <li>
          produtos cujas caracter&iacute;sticas indiquem elevado potencial de
          fraude, pr&aacute;tica de lavagem de dinheiro e financiamento do
          terrorismo ou atividades ilegais, tendo em vistas &agrave;s normas
          aplic&aacute;veis e recomenda&ccedil;&otilde;es de
          &oacute;rg&atilde;os nacionais e internacionais sobre o tema;
        </li>
        <li>
          produtos e cursos que garantam o seu reconhecimento pelos
          &oacute;rg&atilde;os competentes (ex. Minist&eacute;rio da
          Educa&ccedil;&atilde;o, Conselhos de Classe, etc.) sem a respectiva
          comprova&ccedil;&atilde;o de tal reconhecimento;
        </li>
        <li>
          produtos em que a discrep&acirc;ncia entre o pre&ccedil;o cadastrado e
          o valor efetivamente agregado e entregue ao comprador possam, em
          raz&atilde;o do nicho, natureza e peculiaridades do conte&uacute;do,
          indicar fortes ind&iacute;cios de pr&aacute;ticas abusivas e/ou
          irregulares;
        </li>
        <li>
          quaisquer outros produtos cuja venda, divulga&ccedil;&atilde;o e/ou
          explora&ccedil;&atilde;o seja expressamente proibida pelas leis
          vigentes, especialmente violando do C&oacute;digo de Defesa do
          Consumidor, LEI N&ordm; 8.078 DE 11 DE SETEMBRO DE 1990.
        </li>
      </ol>
      <p>
        Cabe ressaltar que, apesar de n&atilde;o realizar qualquer controle
        editorial e/ou revis&atilde;o dos conte&uacute;dos cadastrados na
        PLATAFORMA JUSLABORE, se limitando a an&aacute;lise de conformidade dos
        produtos frente aos Termos de Uso, a JUSLABORE se resguarda ao direito
        de n&atilde;o aceitar e/ou excluir de sua PLATAFORMA JUSLABORE
        conte&uacute;dos que atentem contra a legisla&ccedil;&atilde;o
        aplic&aacute;vel, melhores pr&aacute;ticas perante os consumidores ou
        que v&atilde;o de encontro a cultura da empresa, sendo certo que o
        n&atilde;o cadastramento de tais conte&uacute;dos n&atilde;o gera
        qualquer tipo de direito, dano ou preju&iacute;zo aos USU&Aacute;RIOS.
      </p>
      <ol start="8">
        <li>
          <strong>FUNCIONALIDADE TRIAL</strong>
        </li>
      </ol>
      <p>
        O PRODUTOR poder&aacute; disponibilizar o CONTE&Uacute;DO por meio da
        funcionalidade TRIAL, que representa um per&iacute;odo de
        utiliza&ccedil;&atilde;o gratuita pelo COMPRADOR, que pode variar de 01
        a 30 dias de acordo com a escolha do PRODUTOR. O per&iacute;odo de
        utiliza&ccedil;&atilde;o gratuita (TRIAL) tem a finalidade de permitir
        que novos COMPADORES experimentem o CONTE&Uacute;DO. A
        qualifica&ccedil;&atilde;o ao TRIAL, seu uso e tempo de
        dura&ccedil;&atilde;o &eacute; determinada pelo PRODUTOR a seu exclusivo
        crit&eacute;rio, que poder&aacute; limitar essa
        qualifica&ccedil;&atilde;o para evitar abusos do uso do TRIAL em
        conformidade com as limita&ccedil;&otilde;es e pol&iacute;ticas
        estabelecidas pela JUSLABORE para o uso da funcionalidade. O PRODUTOR
        cobrar&aacute; do COMPRADOR o valor referente a
        disponibiliza&ccedil;&atilde;o do CONTE&Uacute;DO ao final do
        per&iacute;odo de utiliza&ccedil;&atilde;o gratuita, a n&atilde;o ser
        que o COMPRADOR cancele o uso do TRIAL antes do final do per&iacute;odo
        de utiliza&ccedil;&atilde;o gratuita estabelecido pelo PRODUTOR.
      </p>
      <p>
        Ressalta-se que a JUSLABORE, ao realizar qualquer tipo de acordo e/ou
        composi&ccedil;&otilde;es judiciais e extrajudiciais com terceiros,
        n&atilde;o estar&aacute; assumindo, direta ou indiretamente, qualquer
        responsabilidade por produtos e conte&uacute;dos ofertados pelo PRODUTOR
        na PLATAFORMA JUSLABORE, preservando-se assim seu direito de regresso.
        Quaisquer toler&acirc;ncias ou concess&otilde;es realizadas pela
        JUSLABORE, de acordo com sua liberalidade e conveni&ecirc;ncia,
        n&atilde;o constituir&atilde;o precedente invoc&aacute;vel e n&atilde;o
        ter&atilde;o for&ccedil;a de alterar as obriga&ccedil;&otilde;es
        estabelecidas neste instrumento.
      </p>
      <ol start="9">
        <li>
          <strong>INGRESSOS PARA EVENTOS</strong>
        </li>
      </ol>
      <p>
        Em se tratando de produto destinado a venda de ingressos para
        participa&ccedil;&atilde;o em evento criado pelo PRODUTOR organizador,
        sob sua exclusiva responsabilidade, as seguintes regras e
        condi&ccedil;&otilde;es tamb&eacute;m ser&atilde;o aplicadas:
      </p>
      <ol type='a'>
        <li>
          o PRODUTOR deve informar expressamente em sua p&aacute;gina de vendas
          e demais meios de oferta e publica&ccedil;&atilde;o as regras e de
          reembolso e arrependimento eficaz, em especial nos casos em que tal
          prazo seja de at&eacute; 7 (sete) dias a contar da data compra do
          ingresso com a condi&ccedil;&atilde;o de que o pedido de reembolso
          seja feito pelo COMPRADOR com pelo menos 48 (quarenta e oito) horas de
          anteced&ecirc;ncia do hor&aacute;rio de in&iacute;cio do evento. Vale
          lembrar que o PRODUTOR &eacute; exclusivamente respons&aacute;vel pelo
          estabelecimento das regras de reembolso e cancelamento, sendo que
          eventuais reclama&ccedil;&otilde;es de compradores quanto a regra
          estabelecida ser&aacute; de inteira responsabilidade do PRODUTOR;
        </li>
        <li>
          ao cadastrar produto destinado a venda de ingressos, o PRODUTO deve
          garantir que o evento efetivamente ocorrer&aacute;, bem como
          apresentar dados e informa&ccedil;&otilde;es completas absolutamente
          verdadeiras e exatas sobre o evento, em especial, quanto ao local,
          data, hor&aacute;rio, escopo do evento, pre&ccedil;os, lote etc;
        </li>
        <li>
          em caso de cancelamento ou altera&ccedil;&atilde;o de data, local ou
          escopo do evento, al&eacute;m de comunicar seus compradores, o
          PRODUTOR dever&aacute; imediatamente cientificar a JUSLABORE de tal
          ocorr&ecirc;ncia, sob pena de bloqueio de sua(s) conta(s) e valores
          nela(s) existentes;
        </li>
        <li>
          &eacute; responsabilidade exclusiva do PRODUTOR observar e cumprir
          integralmente a legisla&ccedil;&atilde;o aplic&aacute;vel quanto ao
          evento, incluindo, mas n&atilde;o se limitando, &agrave;s normas de
          defesa do consumidor, legisla&ccedil;&atilde;o tribut&aacute;ria, Lei
          9.610/98 (Direitos Autorais) e recolhimento de
          contribui&ccedil;&otilde;es ao ECAD (se aplic&aacute;vel),
          legisla&ccedil;&atilde;o local relativa &agrave;s
          autoriza&ccedil;&atilde;o, licen&ccedil;as e alvar&aacute;s
          necess&aacute;rios para realiza&ccedil;&atilde;o do evento,
          al&eacute;m da Lei 12.933/13 e Decreto 8.537/2015 (pol&iacute;tica de
          meia-entrada) e realizar a classifica&ccedil;&atilde;o indicativa de
          faixa et&aacute;ria informando-a em sua publicidade. Ressalta-se que
          sempre caber&aacute; ao PRODUTOR cumprir a legisla&ccedil;&atilde;o e
          normas locais de sua cidade, estado, pa&iacute;s e/ou regi&atilde;o,
          aplic&aacute;veis ao evento, em todos os seus aspectos;
        </li>
        <li>
          o PRODUTOR, desde j&aacute;, concorda em fornecer a JUSLABORE
          documentos, dados e informa&ccedil;&otilde;es relativos ao local do
          evento e fornecedores e demais envolvidos, permitindo que, caso
          entenda necess&aacute;rio, a JUSLABORE entre em contato com estes;
        </li>
        <li>
          &eacute; vedado ao PRODUTOR cadastrar evento com n&uacute;mero de
          ingressos superior a efetiva capacidade do local onde o evento
          ocorrer&aacute;. Nesse sentido, o PRODUTOR assume possuir plena
          capacidade de cumprir todas as condi&ccedil;&otilde;es anunciadas.
        </li>
      </ol>
      <p>
        A JUSLABORE poder&aacute;, a seu exclusivo crit&eacute;rio, negar o
        cadastramento de evento na PLATAFORMA JUSLABORE caso n&atilde;o sejam
        apresentadas, pelo PRODUTOR, informa&ccedil;&otilde;es que permitam a
        adequada identifica&ccedil;&atilde;o do evento, seus respons&aacute;veis
        e efetiva realiza&ccedil;&atilde;o, bem como caso identifique
        atipicidades que indiquem poss&iacute;veis irregularidades que possam
        impor riscos a direitos de terceiros, incluindo USU&Aacute;RIOS,
        COMPRADORES e a pr&oacute;pria JUSLABORE.
      </p>
      <ol start="10">
        <li>
          <strong>
            REGRAS PARA DIVULGA&Ccedil;&Atilde;O E PROMO&Ccedil;&Atilde;O DE
            CONTE&Uacute;DO POR AFILIADO
          </strong>
        </li>
      </ol>
      <p>
        Para divulgar e promover CONTE&Uacute;DO inclu&iacute;do na PLATAFORMA
        JUSLABORE, o USU&Aacute;RIO dever&aacute;:
      </p>
      <ol type='a'>
        <li>
          registrar-se na PLATAFORMA JUSLABORE como um AFILIADO,
          responsabilizando-se pelo uso apropriado das ferramentas contidas na
          PLATAFORMA JUSLABORE, bem como por buscar o esclarecimento
          necess&aacute;rio nos canais dispon&iacute;veis na PLATAFORMA
          JUSLABORE em caso de d&uacute;vidas;
        </li>
        <li>
          aceitar e respeitar os Termos de Uso e Pol&iacute;ticas da JUSLABORE;
        </li>
        <li>
          candidatar-se para divulgar e promover determinado CONTE&Uacute;DO
          junto ao respectivo PRODUTOR, utilizando-se do campo correto na
          PLATAFORMA JUSLABORE;
        </li>
        <li>
          aceitar os valores e regras de divis&atilde;o das comiss&otilde;es
          determinados pelo PRODUTOR e informados na PLATAFORMA JUSLABORE no
          momento em que se cadastrar como AFILIADO de um determinado
          CONTE&Uacute;DO, reconhecendo que o PRODUTOR &eacute; o &uacute;nico
          respons&aacute;vel por definir o valor e a forma de dividir a
          comiss&atilde;o entre os diversos AFILIADOS que atuem na
          promo&ccedil;&atilde;o do CONTE&Uacute;DO e que tais valores e regras
          podem ser alterados pelo PRODUTOR a seu crit&eacute;rio exclusivo e
          sem necessidade de aviso pr&eacute;vio, levando essa
          condi&ccedil;&atilde;o em conta ao decidir fazer qualquer investimento
          de tempo ou dinheiro na promo&ccedil;&atilde;o de um CONTE&Uacute;DO;
        </li>
        <li>
          utilizar as ferramentas contidas na PLATAFORMA JUSLABORE para permitir
          o rastreamento de sua atua&ccedil;&atilde;o como AFILIADO de
          determinado CONTE&Uacute;DO de seu interesse, sempre em conformidade
          com os Termos de Uso e Pol&iacute;ticas da PLATAFORMA JUSLABORE;
        </li>
        <li>
          responsabilizar-se por reproduzir ao p&uacute;blico para o qual
          divulgar o CONTE&Uacute;DO as caracter&iacute;sticas do
          CONTE&Uacute;DO e as condi&ccedil;&otilde;es de venda inseridas pelo
          PRODUTOR na PLATAFORMA JUSLABORE, assumindo solidariamente ao PRODUTOR
          a responsabilidade pelo cumprimento integral de tais
          condi&ccedil;&otilde;es junto ao COMPRADOR;
        </li>
        <li>
          aceitar a regra de que as vendas realizadas com uso das ferramentas
          tecnol&oacute;gicas de rastreamento contidas na PLATAFORMA JUSLABORE
          gerar&atilde;o comiss&otilde;es ao AFILIADO, que ser&atilde;o devidas
          apenas ap&oacute;s a finaliza&ccedil;&atilde;o da venda e o efetivo
          pagamento pelo COMPRADOR, e apenas poder&atilde;o ser resgatados
          conforme regras contidas no item GEST&Atilde;O DE PAGAMENTOS;
        </li>
        <li>
          aceitar utilizar, como meio de recebimento de suas comiss&otilde;es,
          somente as plataformas de pagamentos cuja funcionalidade de
          &ldquo;checkout&rdquo; esteja integrada &agrave; PLATAFORMA JUSLABORE,
          considerando todas as regras e limita&ccedil;&otilde;es daquelas
          plataformas, que podem ser verificadas em seus respectivos sites,
          responsabilizando-se por realizar o seu registro junto aos respectivos
          meios de pagamento;
        </li>
        <li>
          arcar com as TARIFAS decorrentes do uso das ferramentas
          tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE e arcar com suas
          obriga&ccedil;&otilde;es legais, regulat&oacute;rias, fiscais,
          trabalhistas e tribut&aacute;rias, se, quando e onde existentes.
        </li>
      </ol>
      <ol start="11">
        <li>
          <strong>DIRETRIZES GERAIS AO USU&Aacute;RIO</strong>
        </li>
      </ol>
      <p>
        Sem preju&iacute;zo de outras regras previstas nestes Termos de Uso,
        &eacute; vedado ao USU&Aacute;RIO:
      </p>
      <ol type='a'>
        <li>
          COPIAR, MODIFICAR, REPRODUZIR, DISTRIBUIR, FAZER DOWNLOAD, ARMAZENAR,
          TRANSMITIR, VENDER, REVENDER, FAZER ENGENHARIA REVERSA OU CRIAR
          PRODUTOS DERIVADOS DE QUALQUER CONTE&Uacute;DO DISPON&Iacute;VEL NA
          PLATAFORMA JUSLABORE;
        </li>
        <li>
          (ii) violar ou tentar violar quaisquer medidas de seguran&ccedil;a da
          PLATAFORMA JUSLABORE, ou tirar proveito de qualquer
          inconsist&ecirc;ncia do sistema para obter vantagem para si
          pr&oacute;prio ou para terceiros, ou causar preju&iacute;zo &agrave;
          JUSLABORE e/ou a terceiros, especialmente ao acessar ou tentar acessar
          qualquer conta de USU&Aacute;RIO da PLATAFORMA JUSLABORE, ou, ainda,
          ao obter e divulgar a senha de USU&Aacute;RIO da PLATAFORMA JUSLABORE;
        </li>
        <li>
          (iii)submeter &agrave; PLATAFORMA JUSLABORE qualquer
          informa&ccedil;&atilde;o falsa, imprecisa ou incompleta;
        </li>
        <li>(iv) manipular pre&ccedil;os de CONTE&Uacute;DO;</li>
        <li>
          (v) interferir nas transa&ccedil;&otilde;es realizadas entre outros
          USU&Aacute;RIOS;
        </li>
        <li>(vi) passar-se por outra pessoa ou organiza&ccedil;&atilde;o;</li>
        <li>
          (vii) usar &ldquo;SPAM&rdquo; ou qualquer outra pr&aacute;tica de
          divulga&ccedil;&atilde;o ou capta&ccedil;&atilde;o de
          informa&ccedil;&atilde;o inapropriada, caluniosa ou ilegal para
          promover qualquer CONTE&Uacute;DO inserido na PLATAFORMA JUSLABORE;
        </li>
        <li>
          comprar CONTE&Uacute;DO por meio de seu pr&oacute;prio
          &ldquo;link&rdquo; de AFILIADO e/ou usar &ldquo;link&rdquo; de
          AFILIADOS de seu pr&oacute;prio CONTE&Uacute;DO em sua p&aacute;gina
          de vendas, substituir o &ldquo;link&rdquo; de AFILIADO constante de
          uma p&aacute;gina de vendas, em benef&iacute;cio pr&oacute;prio ou de
          terceiros;
        </li>
        <li>
          agredir, caluniar, injuriar ou difamar outros USU&Aacute;RIOS e/ou
          terceiros;
        </li>
      </ol>
      <ol start="12">
        <li>
          <strong>GEST&Atilde;O DE PAGAMENTOS</strong>
        </li>
      </ol>
      <p>As ferramentas contidas na PLATAFORMA JUSLABORE pode permitir:</p>
      <ol type='a'>
        <li>
          o pagamento pelos COMPRADORES pela aquisi&ccedil;&atilde;o de
          CONTE&Uacute;DOS inseridos na PLATAFORMA JUSLABORE;
        </li>
        <li>
          o pagamento pelos PRODUTORES aos AFILIADOS dos valores devidos pela
          divulga&ccedil;&atilde;o de CONTE&Uacute;DOS;
        </li>
        <li>
          o recebimento pelos PRODUTORES dos valores relativos &agrave;
          comercializa&ccedil;&atilde;o de seus CONTE&Uacute;DOS;
        </li>
        <li>
          o recebimento pelos AFILIADOS dos valores relativos &agrave;
          divulga&ccedil;&atilde;o de CONTE&Uacute;DOS comercializados.
        </li>
      </ol>
      <p>
        No momento em que se cadastra na PLATAFORMA JUSLABORE o PRODUTOR
        concorda e solicita que a JUSLABORE promova:
      </p>
      <ol type='a'>
        <li>o recebimento do pre&ccedil;o pago pelo COMPRADOR;</li>
        <li>
          o pagamento da remunera&ccedil;&atilde;o estabelecida ao AFILIADO
          pelo PRODUTOR, quando houver;
        </li>
        <li>
          a dedu&ccedil;&atilde;o da remunera&ccedil;&atilde;o devida
          &agrave; JUSLABORE pela utiliza&ccedil;&atilde;o de suas ferramentas;
        </li>
        <li>o pagamento do valor remanescente devido ao PRODUTOR.</li>
      </ol>
      <p>
        O USU&Aacute;RIO declara-se ciente de que as ferramentas de
        gest&atilde;o de pagamentos contidas na PLATAFORMA JUSLABORE n&atilde;o
        s&atilde;o e nem se destinam a ser compar&aacute;veis aos
        servi&ccedil;os financeiros oferecidos por institui&ccedil;&otilde;es
        banc&aacute;rias ou administradoras de cart&atilde;o de cr&eacute;dito,
        consistindo apenas em uma forma de facilita&ccedil;&atilde;o e
        acompanhamento da realiza&ccedil;&atilde;o de transa&ccedil;&otilde;es
        para pagamentos e recebimentos entre os USU&Aacute;RIOS da PLATAFORMA
        JUSLABORE.
      </p>
      <p>
        Apesar de as ferramentas contidas na PLATAFORMA JUSLABORE serem o meio
        de pagamento exclusivo para as transa&ccedil;&otilde;es realizadas com
        CONTE&Uacute;DOS nela inseridos, a JUSLABORE poder&aacute; se utilizar
        de meios de pagamento de terceiros tais como institui&ccedil;&otilde;es
        financeiras, administradoras de cart&otilde;es de cr&eacute;dito e
        outras entidades para promover o recebimento e pagamento de tais
        transa&ccedil;&otilde;es.
      </p>
      <p>
        Al&eacute;m disso, todas as opera&ccedil;&otilde;es de
        comercializa&ccedil;&atilde;o ser&atilde;o verificadas pelas ferramentas
        de gest&atilde;o de risco integradas &agrave; PLATAFORMA JUSLABORE e
        poder&atilde;o ser recusadas sempre que houver suspeita de fraude aos
        meios de pagamento ou infra&ccedil;&atilde;o &agrave; lei ou aos Termos
        de Uso.
      </p>
      <ol start="13">
        <li>
          <strong>
            TARIFAS PELO USO DAS FERRAMENTAS CONTIDAS NA PLATAFORMA JUSLABORE
          </strong>
        </li>
      </ol>
      <p>
        O uso das ferramentas tecnol&oacute;gicas contidas na PLATAFORMA
        JUSLABORE pelo PRODUTOR est&aacute; sujeito ao pagamento de uma TARIFA
        DE LICEN&Ccedil;A, que cobrada por um valor fixo, podendo ser acrescido
        de cobran&ccedil;a pelo servi&ccedil;o de intermedia&ccedil;&atilde;o, a
        TARIFA DE INTERMEDIA&Ccedil;&Atilde;O, a ser definida no ato da
        libera&ccedil;&atilde;o da funcionalidade espec&iacute;fica.
      </p>
      <ol start="14">
        <li>
          <strong>REGRAS PARA SAQUE DE VALORES ACUMULADOS</strong>
        </li>
      </ol>
      <p>
        Os valores de comiss&otilde;es a que fizerem jus os AFILIADOS e os
        valores relativos &agrave;s VENDAS realizadas pelos PRODUTORES
        poder&atilde;o ter seu resgate solicitado pelos respectivos
        USU&Aacute;RIOS ap&oacute;s o prazo de 30 dias e desde que o valor
        acumulado seja suficiente para a reten&ccedil;&atilde;o da TARIFA DE
        SAQUE e para permitir o saque de no m&iacute;nimo R$ 20,00 (vinte
        reais).
      </p>
      <p>
        O valor m&iacute;nimo de saque tamb&eacute;m ser&aacute; considerado
        para fins de encerramento de conta, ficando o USU&Aacute;RIO ciente
        desde j&aacute;, tendo esse o escopo de cobrir as tarifas inerentes ao
        saque e transa&ccedil;&otilde;es realizadas.
      </p>
      <p>
        TARIFAS ADICIONAIS &ndash; A op&ccedil;&atilde;o pelo uso de
        funcionalidades adicionais tais como a possibilidade de oferecer
        parcelamento do pre&ccedil;o de oferta pelo CONTE&Uacute;DO e receber o
        valor &agrave; vista, bem como a possibilidade de antecipar o direito de
        saque de valores acumulados em suas contas pode estar sujeito ao
        pagamento pelo PRODUTOR ou pelo AFILIADO de TARIFAS ADICIONAIS, o que
        ser&aacute; sempre informado previamente &agrave;
        contrata&ccedil;&atilde;o da funcionalidade espec&iacute;fica.
      </p>
      <p>
        Os PRODUTORES e AFILIADOS, desde j&aacute;, nomeiam a JUSLABORE BR sua
        bastante procuradora com poderes especiais para, em seu nome e por sua
        conta, receber e transferir os valores relativos &agrave;
        comercializa&ccedil;&atilde;o dos respectivos PRODUTOS devidos pelos
        COMPRADORES, outorgando-lhe poderes especiais para assinar outros
        contratos que se fa&ccedil;am necess&aacute;rios nesse contexto, sem,
        contudo, ter que substabelecer em todo ou em parte o mandato outorgado.
      </p>
      <p>
        A JUSLABORE dever&aacute; efetuar a transfer&ecirc;ncia aos PRODUTORES e
        AFILIADOS dos valores relativos &agrave; comercializa&ccedil;&atilde;o
        dos PRODUTOS devidos pelos COMPRADORES, deduzida da
        remunera&ccedil;&atilde;o devida &agrave; JUSLABORE pela
        utiliza&ccedil;&atilde;o das ferramentas contidas na PLATAFORMA
        JUSLABORE, por meio de transfer&ecirc;ncia de fundos imediatamente
        dispon&iacute;veis (TEDs), boleto banc&aacute;rio e/ou qualquer outro
        meio de transfer&ecirc;ncia de fundos, conforme disposto nestes Termos
        de Uso.
      </p>
      <p>
        Os USU&Aacute;RIOS, em especial PRODUTORES e AFILIADOS, concordam que
        n&atilde;o poder&atilde;o, em qualquer hip&oacute;tese, contratar
        opera&ccedil;&otilde;es de cr&eacute;dito junto a
        institui&ccedil;&otilde;es financeiras concedendo como garantia os
        receb&iacute;veis constitu&iacute;dos e/ou a constituir decorrentes das
        transa&ccedil;&otilde;es realizadas atrav&eacute;s da PLATAFORMA
        JUSLABORE, tendo em vista que tais receb&iacute;veis representam,
        at&eacute; sua integraliza&ccedil;&atilde;o e efetivo saque pelo
        USU&Aacute;RIO, garantia de cumprimento das obriga&ccedil;&otilde;es e
        responsabilidades dos USU&Aacute;RIOS perante COMPRADORES e para com a
        pr&oacute;pria JUSLABORE. Viola&ccedil;&atilde;o a est&aacute;
        veda&ccedil;&atilde;o poder&aacute; ser punida com o bloqueio e
        reten&ccedil;&atilde;o dos valores integralizados e/ou a integralizar na
        conta do USU&Aacute;RIO at&eacute; o limite da opera&ccedil;&atilde;o de
        cr&eacute;dito contratada pelo USU&Aacute;RIO, bem como com sua
        exclus&atilde;o da PLATAFORMA JUSLABORE.
      </p>
      <p>
        De acordo com a legisla&ccedil;&atilde;o aplic&aacute;vel, cada
        USU&Aacute;RIO &eacute; respons&aacute;vel por pelo recolhimento dos
        impostos/reten&ccedil;&otilde;es originados em raz&atilde;o das
        transa&ccedil;&otilde;es realizadas na PLATAFORMA JUSLABORE. Assim, o
        PRODUTOR responsabiliza-se por emitir e encaminhar o documento fiscal
        referente &agrave; disponibiliza&ccedil;&atilde;o do CONTE&Uacute;DO ao
        COMPRADOR.
      </p>
      <p>
        Ainda, como forma de evitar a sonega&ccedil;&atilde;o fiscal, o valor
        mensal de saque para USU&Aacute;RIOS brasileiros, cadastrados na
        PLATAFORMA JUSLABORE como pessoa natural, estar&aacute; limitado os
        valores inseridos nas faixas de n&atilde;o incid&ecirc;ncia
        tribut&aacute;ria, conforme legisla&ccedil;&atilde;o tribut&aacute;ria e
        fiscal vigentes.
      </p>
      <p>
        Para as compras parceladas poder&aacute; haver a cobran&ccedil;a de
        tarifas administrativas para o processamento do parcelamento realizado
        pelo COMPRADOR, bem como incid&ecirc;ncia de tarifas no valor a ser
        cobrado do COMPRADOR. Essas tarifas n&atilde;o ser&atilde;o repassadas
        aos PRODUTORES e ou AFILIADOS.
      </p>
      <p>
        Tendo em vista que os PRODUTORES s&atilde;o inteira e exclusivamente
        respons&aacute;veis pelos produtos e conte&uacute;dos ofertados aos
        COMPRADORES, incluindo, mas n&atilde;o se limitando, as
        informa&ccedil;&otilde;es, caracter&iacute;sticas, qualidades,
        quantidade, composi&ccedil;&atilde;o, pre&ccedil;o, garantia, prazos de
        validade e entrega, eventuais reclama&ccedil;&otilde;es e disputas
        relacionadas ao produto, sua qualidade, entrega e/ou acesso ao
        conte&uacute;do, pedidos de reembolso e etc., dever&atilde;o ser
        tratadas pelos PRODUTORES, diretamente com os COMPRADORES, por meio dos
        seus canais de atendimento e suporte.
      </p>
      <p>
        Nesse sentido, caso a JUSLABORE venha a responder administrativa ou
        judicialmente pelo conte&uacute;do, de qualquer natureza e
        esp&eacute;cie, gerado pelos PRODUTORES, os valores despendidos pela
        JUSLABORE poder&atilde;o, a seu crit&eacute;rio exclusivo, ser abatidos
        das comiss&otilde;es, saldos contratuais e demais valores devidos ao
        PRODUTOR respons&aacute;vel at&eacute; o limite necess&aacute;rio
        &agrave; recomposi&ccedil;&atilde;o dos custos incorridos pela JUSLABORE
        em raz&atilde;o de acordos extrajudiciais e judiciais firmados com
        COMPRADORES, bem como condena&ccedil;&otilde;es judiciais. Desde
        j&aacute;, os PRODUTORES concordam e autorizam a reten&ccedil;&atilde;o
        e/ou cobran&ccedil;a dos referidos valores, pela JUSLABORE BR, nos
        termos acima e do art. 784, III, do CPC.
      </p>
      <p>
        Ressalta-se que a JUSLABORE, ao realizar qualquer tipo de acordo e/ou
        composi&ccedil;&otilde;es judiciais e extrajudiciais com COMPRADORES,
        n&atilde;o estar&aacute; assumindo, direta ou indiretamente, qualquer
        responsabilidade por produtos e conte&uacute;dos ofertados pelos
        PRODUTORES, preservando-se assim seu direito de regresso. Quaisquer
        toler&acirc;ncias ou concess&otilde;es realizadas pela JUSLABORE, de
        acordo com sua liberalidade e conveni&ecirc;ncia, n&atilde;o
        constituir&atilde;o precedente invoc&aacute;vel e n&atilde;o
        ter&atilde;o o cond&atilde;o de alterar as obriga&ccedil;&otilde;es
        estabelecidas neste instrumento.
      </p>
      <ol start="15">
        <li>
          <strong>DIREITOS AUTORAIS</strong>
        </li>
      </ol>
      <p>
        As informa&ccedil;&otilde;es contidas na PLATAFORMA JUSLABORE, bem como
        as marcas, nome empresarial, nome de dom&iacute;nio, programas, bancos
        de dados, redes e arquivos s&atilde;o titularidade da JUSLABORE
        est&atilde;o protegidos pelas leis e tratados de propriedade
        intelectual, sendo absolutamente vedada a c&oacute;pia,
        distribui&ccedil;&atilde;o, uso ou publica&ccedil;&atilde;o, total ou
        parcial, de qualquer material, parte do site e dos CONTE&Uacute;DOS nele
        ofertados sem pr&eacute;via e expressa autoriza&ccedil;&atilde;o.
      </p>
      <p>
        Os PRODUTORES ficam, desde j&aacute;, cientes do risco de terceiros
        criarem CONTE&Uacute;DOS com a mesma &ldquo;ideia&rdquo; dos
        comercializados por meio da PLATAFORMA JUSLABORE, considerando a grande
        visualiza&ccedil;&atilde;o de acessos que a rede mundial de computadores
        proporciona. No entanto, declaram reconhecer que a JUSLABORE n&atilde;o
        pode impedir que isso ocorra, nem tem responsabilidade sobre essa
        situa&ccedil;&atilde;o, que foge completamente de seu controle, tendo em
        vista que ideias n&atilde;o s&atilde;o protegidas pela
        legisla&ccedil;&atilde;o aplic&aacute;vel e que a
        configura&ccedil;&atilde;o de pl&aacute;gio &eacute; algo muito
        subjetivo que pode precisar ser avaliado pelo Poder Judici&aacute;rio.
      </p>
      <ol start="16">
        <li>
          <strong>
            MECANISMOS DE DEN&Uacute;NCIAS E RESOLU&Ccedil;&Atilde;O DE DISPUTAS
          </strong>
        </li>
      </ol>
      <p>
        Considerando que a PLATAFORMA JUSLABORE n&atilde;o &eacute; a criadora
        do CONTE&Uacute;DO produzido e publicado pelo PRODUTOR e que n&atilde;o
        h&aacute; controle editorial pr&eacute;vio dos CONTE&Uacute;DOS, a
        JUSLABORE, nos termos da legisla&ccedil;&atilde;o aplic&aacute;vel,
        n&atilde;o &eacute; respons&aacute;vel pelos CONTE&Uacute;DOS
        divulgados.
      </p>
      <p>
        Com isso, a JUSLABORE oferece mecanismos eficientes para que
        USU&Aacute;RIOS que entendam ter tido algum direito seu violado possam
        fazer den&uacute;ncias e busquem resolver suas disputas, conforme abaixo
        indicado.
      </p>
      <ol start="17">
        <li>
          <strong>
            DISPUTAS A RESPEITO DA QUALIDADE DO CONTE&Uacute;DO E DA
            AVALIA&Ccedil;&Atilde;O DO PRODUTOR
          </strong>
        </li>
      </ol>
      <p>
        A JUSLABORE recomenda que toda transa&ccedil;&atilde;o seja realizada
        com cautela e bom senso.
      </p>
      <p>
        Caso o COMPRADOR decida realizar uma transa&ccedil;&atilde;o e se sinta
        lesado em rela&ccedil;&atilde;o &agrave; qualidade do CONTE&Uacute;DO
        adquirido, o COMPRADOR poder&aacute; enviar, dentro do prazo de garantia
        estipulado pelo PRODUTOR reclama&ccedil;&atilde;o atrav&eacute;s do
        link&ldquo;&rdquo; &lt;
        <Link to="https://www.juslabore.com.br/contato">
          https://www.juslabore.com.br/contato
        </Link>
        &gt;.
      </p>
      <p>
        Uma vez enviada a reclama&ccedil;&atilde;o
        pelo&rdquo;link&rdquo;indicado e dentro do prazo de garantia do
        CONTE&Uacute;DO, tendo em vista que o PRODUTOR continua sendo
        respons&aacute;vel pelos aspectos t&eacute;cnicos e de qualidade do
        CONTE&Uacute;DO gerado, a JUSLABORE comunicar&aacute; o PRODUTOR em
        quest&atilde;o e conceder&aacute; o prazo de at&eacute; 10 (dez) dias
        corridos para que ele responda a reclama&ccedil;&atilde;o com uma
        justificativa ou tentativa de sanar o problema. Caso o PRODUTOR
        n&atilde;o entre em contato neste prazo, a solicita&ccedil;&atilde;o de
        reembolso de poder&aacute; ser executada de forma autom&aacute;tica,
        al&eacute;m de poderem ser fornecidos dados do PRODUTOR ao COMPRADOR,
        conforme Pol&iacute;tica de Privacidade.
      </p>
      <p>
        Ocorrendo uma disputa entre COMPRADOR e PRODUTOR que n&atilde;o puder
        ser resolvida pelos meios aqui estabelecidos, a JUSLABORE poder&aacute;
        promover a a&ccedil;&atilde;o judicial dos valores envolvidos.
      </p>
      <ol start="18">
        <li>
          <strong>
            DISPUTAS A RESPEITO DE OFENSAS AOS DIREITOS DA PERSONALIDADE:
            CAL&Uacute;NIA, INJ&Uacute;RIA OU DIFAMA&Ccedil;&Atilde;O
          </strong>
        </li>
      </ol>
      <p>
        Caso algu&eacute;m entenda que algum CONTE&Uacute;DO viole seus direitos
        de personalidade, tais como, a honra, a imagem, a voz, o nome, a
        intimidade, poder&aacute; enviar uma reclama&ccedil;&atilde;o
        preenchendo o Formul&aacute;rio disponibilizado no link&nbsp;
        <em>
          <Link to="https://www.juslabore.com.br/contato">
            http://www.juslabore.com.br/contato.
          </Link>
          .br
        </em>
      </p>
      <p>
        Uma vez preenchido o Formul&aacute;rio, a JUSLABORE, caso n&atilde;o se
        trate de uma hip&oacute;tese que autorize/justifique a imediata
        remo&ccedil;&atilde;o do CONTE&Uacute;DO, de acordo com estes Termos de
        Uso, comunicar&aacute; ao PRODUTOR e conceder&aacute; o prazo de
        at&eacute; 10 dias para que ele responda a reclama&ccedil;&atilde;o com
        uma justificativa.
      </p>
      <p>
        Caso o PRODUTOR n&atilde;o se manifeste no prazo, a JUSLABORE
        poder&aacute;, mas n&atilde;o estar&aacute; obrigada a remover o
        CONTE&Uacute;DO denunciado, dando ci&ecirc;ncia ao Notificante e
        comunicando a medida ao PRODUTOR.
      </p>
      <p>
        Caso o PRODUTOR reconhe&ccedil;a a ilicitude do CONTE&Uacute;DO, a
        JUSLABORE remover&aacute; o CONTE&Uacute;DO, dando ci&ecirc;ncia ao
        Notificante.
      </p>
      <p>
        Caso o PRODUTOR manifeste-se sustentando a licitude do CONTE&Uacute;DO,
        as partes ser&atilde;o cientificadas que foi instaurada uma disputa cuja
        decis&atilde;o est&aacute; al&eacute;m das prerrogativas da JUSLABORE, e
        que a remo&ccedil;&atilde;o do CONTE&Uacute;DO s&oacute; ser&aacute;
        efetivada mediante ordem judicial nesse sentido.
      </p>
      <ol start="19">
        <li>
          <strong>
            DISPUTAS A RESPEITO DE VIOLA&Ccedil;&Atilde;O A DIREITOS DE
            PROPRIEDADE INTELECTUAL
          </strong>
        </li>
      </ol>
      <p>
        Caso algu&eacute;m entenda que um CONTE&Uacute;DO inserido na PLATAFORMA
        JUSLABORE viola seus direitos de propriedade industrial (marca, patente,
        desenhos industriais) ou seus direitos autorais, poder&aacute; notificar
        a JUSLABORE, preenchendo o Formul&aacute;rio de contato, indicando a URL
        em que o CONTE&Uacute;DO em quest&atilde;o se encontra, bem como
        anexando ao formul&aacute;rio a comprova&ccedil;&atilde;o de ser o
        titular do direito violado ou seu representante legal, via documentos
        juridicamente adequados para comprovar sua titularidade sobre o
        CONTE&Uacute;DO.
      </p>
      <p>
        Ao iniciar o procedimento disputas a respeito de viola&ccedil;&atilde;o
        a direitos de propriedade intelectual, todos os envolvidos concordam
        automaticamente com os termos e condi&ccedil;&otilde;es expressos na
        Pol&iacute;tica de Notifica&ccedil;&otilde;es sobre
        Viola&ccedil;&otilde;es de Direitos Intelectuais da PLATAFORMA
        JUSLABORE&nbsp;
        <span>
          <Link to="https://www.juslabore.com.br/termos-de-uso">
            https://www.juslabore.com.br/termos-de-uso.
          </Link>
        </span>
      </p>
      <p>
        Notificar a PLATAFORMA JUSLABORE a respeito de uma
        viola&ccedil;&atilde;o de direitos &eacute; um assunto s&eacute;rio com
        consequ&ecirc;ncias jur&iacute;dicas. Em caso de d&uacute;vida sobre a
        infra&ccedil;&atilde;o, recomenda-se buscar orienta&ccedil;&atilde;o
        jur&iacute;dica. Antes de enviar uma Notifica&ccedil;&atilde;o, o
        USU&Aacute;RIO deve sempre lembrar que existem exce&ccedil;&otilde;es e
        limita&ccedil;&otilde;es aos direitos de cada um. O envio de
        den&uacute;ncias enganosas sobre infra&ccedil;&otilde;es pode ser
        pun&iacute;vel por lei.
      </p>
      <ol start="20">
        <li>
          <strong>
            DISPUTAS A RESPEITO DE DIVULGA&Ccedil;&Atilde;O, SEM
            AUTORIZA&Ccedil;&Atilde;O DE SEUS PARTICIPANTES, DE IMAGENS,
            V&Iacute;DEOS OU OUTROS MATERIAIS CONTENDO CENAS DE NUDEZ OU DE ATOS
            SEXUAIS DE CAR&Aacute;TER PRIVADO
          </strong>
        </li>
      </ol>
      <p>
        Caso algu&eacute;m tome conhecimento de que um CONTE&Uacute;DO inserido
        na PLATAFORMA JUSLABORE contenha cenas de nudez ou de atos sexuais de
        car&aacute;ter privado a seu respeito, poder&aacute; notificar a
        JUSLABORE, por meio do Formul&aacute;rio
        <span>
          <Link to="https://www.juslabore.com.br/contato/">
            https://www.juslabore.com.br/contato/
          </Link>
        </span>
        indicando a URL em que o CONTE&Uacute;DO em quest&atilde;o se encontra,
        bem como anexando ao formul&aacute;rio a comprova&ccedil;&atilde;o de
        ser o participante da cena ou seu representante legal.
      </p>
      <p>
        Uma vez preenchido o Formul&aacute;rio Formul&aacute;rio de contato a
        JUSLABORE verificar&aacute; os requisitos de validade da
        notifica&ccedil;&atilde;o, conforme indicado acima, e constatada a
        exist&ecirc;ncia de cenas de nudez ou de atos sexuais de car&aacute;ter
        privado, providenciar&aacute; em at&eacute; 10 dias corridos a
        remo&ccedil;&atilde;o do CONTE&Uacute;DO, dando ci&ecirc;ncia ao
        Notificante e informando ao PRODUTOR respons&aacute;vel a
        san&ccedil;&atilde;o a ele aplic&aacute;vel, que poder&aacute; ser
        at&eacute; o cancelamento definitivo do seu cadastro, a crit&eacute;rio
        exclusivo da JUSLABORE.
      </p>
      <ol start="21">
        <li>
          <strong>
            RELA&Ccedil;&Atilde;O ENTRE USU&Aacute;RIOS E A JUSLABORE
          </strong>
        </li>
      </ol>
      <p>
        Sem preju&iacute;zo do j&aacute; previsto nestes Termos de Uso, a
        rela&ccedil;&atilde;o entre a JUSLABORE e os USU&Aacute;RIOS se
        reger&aacute; pelo seguinte:
      </p>
      <ol type='a'>
        <li>
          a JUSLABORE &eacute; respons&aacute;vel pela guarda dos dados de
          cadastro dos USU&Aacute;RIOS, bem como pelos dados relativos &agrave;s
          transa&ccedil;&otilde;es realizadas com as ferramentas
          tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE nos termos da
          legisla&ccedil;&atilde;o aplic&aacute;vel;
        </li>
        <li>
          os USU&Aacute;RIOS ser&atilde;o &uacute;nica e exclusivamente
          respons&aacute;veis por manter todos os dados e
          informa&ccedil;&otilde;es cadastrais devidamente atualizados, revendo
          e atualizando seus dados, no m&iacute;nimo, a cada 6 (seis) meses,
          responsabilizando pela veracidade, legalidade e
          adequa&ccedil;&atilde;o de todos os documentos e
          informa&ccedil;&otilde;es inseridos no sistema durante o cadastramento
          na PLATAFORMA JUSLABORE. Caso sejam identificadas
          inconsist&ecirc;ncias ou desatualiza&ccedil;&atilde;o dos dados e
          informa&ccedil;&otilde;es cadastrais, a JUSLABORE poder&aacute;
          proceder com a imediata suspens&atilde;o da conta do USU&Aacute;RIO
          at&eacute; que esta seja regularizada;
        </li>
        <li>
          a JUSLABORE ir&aacute; trabalhar junto com o comprador para resolver
          quaisquer problemas originados pela venda, a JUSLABORE ser&aacute;
          totalmente respons&aacute;vel por quaisquer disputas abertas pelos
          compradores, como &ldquo;chargebacks&rdquo;, reclama&ccedil;&otilde;es
          diversas, cancelamento e estornos, mas reserva o direito de deduzir
          estes valores do pagamento dos produtores e/ou afiliados;
        </li>
        <li>
          considerando que o PRODUTOR continua sendo respons&aacute;vel pelos
          aspectos t&eacute;cnicos e de qualidade do CONTE&Uacute;DO gerado, a
          JUSLABORE comunicar&aacute; o PRODUTOR em quest&atilde;o e
          conceder&aacute; o prazo de at&eacute; 10 (dez) dias corridos para que
          este responda a reclama&ccedil;&otilde;es relativas ao CONTE&Ugrave;DO
          ofertado na PLATAFORMA JUSLABORE, com uma justificativa ou tentativa
          de sanar o problema. Caso o PRODUTOR n&atilde;o entre em contato com a
          JUSLABORE neste prazo, eventuais solicita&ccedil;&otilde;es de
          reembolso poder&atilde;o ser executadas de forma autom&aacute;tica,
          observadas as disposi&ccedil;&otilde;es deste Termos de Uso;
        </li>
        <li>
          a PLATAFORMA JUSLABORE envidar&aacute; todos os esfor&ccedil;os para
          manter a continuidade e a disponibilidade das ferramentas
          tecnol&oacute;gicas contidas na PLATAFORMA JUSLABORE. Entretanto, por
          raz&otilde;es t&eacute;cnicas e que fugirem ao seu controle, a
          PLATAFORMA JUSLABORE poder&aacute; ficar indispon&iacute;vel por algum
          per&iacute;odo;
        </li>
        <li>
          a PLATAFORMA JUSLABORE n&atilde;o se responsabiliza: (i) por qualquer
          dano, preju&iacute;zo ou perda no equipamento do USU&Aacute;RIO
          causada por falhas no sistema, no servidor ou na internet decorrentes
          de condutas de terceiros; (ii) por danos decorrentes de ataques de
          v&iacute;rus ao equipamento do USU&Aacute;RIO em decorr&ecirc;ncia do
          acesso, utiliza&ccedil;&atilde;o ou navega&ccedil;&atilde;o na
          PLATAFORMA JUSLABORE ou como consequ&ecirc;ncia da transfer&ecirc;ncia
          de dados, arquivos, imagens, textos ou &aacute;udio;
        </li>
        <li>
          os USU&Aacute;RIOS isentam a PLATAFORMA JUSLABORE de responsabilidade
          por danos suportados em virtude de preju&iacute;zos resultantes de
          dificuldades t&eacute;cnicas ou falhas nos sistemas ou na internet.
        </li>
        <li>
          a PLATAFORMA JUSLABORE n&atilde;o se responsabilizar&aacute; por erros
          na divulga&ccedil;&atilde;o de CONTE&Uacute;DO com a
          utiliza&ccedil;&atilde;o das ferramentas contidas na PLATAFORMA
          JUSLABORE, que possam dificultar a venda de tal CONTE&Uacute;DO.
        </li>
        <li>
          as tarifas e os meios de pagamento poder&atilde;o ser alterados
          conforme estrat&eacute;gia da PLATAFORMA JUSLABORE, a seu exclusivo
          crit&eacute;rio, sem necessidade de notifica&ccedil;&atilde;o
          pr&eacute;via aos USU&Aacute;RIOS;
        </li>
        <li>
          a PLATAFORMA JUSLABORE n&atilde;o &eacute; respons&aacute;vel pela
          qualidade dos CONTE&Uacute;DOS, mas recomenda que os PRODUTORES prezem
          pela qualidade dos CONTE&Uacute;DOS oferecidos na PLATAFORMA
          JUSLABORE;
        </li>
        <li>
          os CONTE&Uacute;DOS inclu&iacute;dos na PLATAFORMA JUSLABORE apenas
          permanecer&atilde;o disponibilizados para divulga&ccedil;&atilde;o se
          estiverem de acordo com estes Termos de Uso. A PLATAFORMA JUSLABORE
          reserva-se o direito de remover qualquer CONTE&Uacute;DO que
          n&atilde;o esteja de acordo suas normas e pol&iacute;ticas;
        </li>
        <li>
          a PLATAFORMA JUSLABORE n&atilde;o &eacute; respons&aacute;vel pelo
          efetivo cumprimento das obriga&ccedil;&otilde;es assumidas pelos
          USU&Aacute;RIOS;
        </li>
        <li>
          a PLATAFORMA JUSLABORE n&atilde;o &eacute; respons&aacute;vel por
          eventuais contesta&ccedil;&otilde;es, &ldquo;chargebacks&rdquo; ou
          bloqueios de compra/pagamento de qualquer natureza por parte do
          COMPRADOR e poder&aacute; deduzir a qualquer tempo do saldo do
          USU&Aacute;RIO valores referentes a transa&ccedil;&otilde;es
          reembolsadas ou bloqueadas, ou transa&ccedil;&otilde;es contestadas
          (chargeback);
        </li>
        <li>
          a PLATAFORMA JUSLABORE N&Atilde;O SE RESPONSABILIZA PELO USO INDEVIDO
          DA PLATAFORMA POR TERCEIROS, sejam PRODUTORES, COMPRADORES OU
          AFILIADOS, seja a que t&iacute;tulo for, especialmente em caso de
          divulga&ccedil;&atilde;o em outras plataformas de CONTE&Uacute;DOS
          previamente adquiridos;
        </li>
        <li>
          Os USU&Aacute;RIOS reconhecem que o &ldquo;site&rdquo; da PLATAFORMA
          JUSLABORE pode conter &ldquo;links&rdquo; para outros
          &ldquo;sites&rdquo; da rede, o que n&atilde;o significa que estes
          sejam de propriedade ou operados pela PLATAFORMA JUSLABORE;
        </li>
        <li>
          a PLATAFORMA JUSLABORE n&atilde;o se responsabiliza pelos materiais,
          informa&ccedil;&otilde;es ou conte&uacute;do publicados em
          &ldquo;sites&rdquo; de terceiros, tampouco pela disponibilidade destes
          sites, competindo ao USU&Aacute;RIO usar seu pr&oacute;prio
          discernimento, precau&ccedil;&atilde;o e senso comum ao acessar
          &ldquo;sites&rdquo; de terceiros, devendo conferir as pol&iacute;ticas
          de privacidade e os termos de uso aplic&aacute;veis;
        </li>
        <li>
          todas as informa&ccedil;&otilde;es fornecidas pelo USU&Aacute;RIO
          &agrave; PLATAFORMA JUSLABORE s&atilde;o armazenadas e tratadas na
          forma indicada na Pol&iacute;tica de Privacidade.
        </li>
        <li>
          considerando a proposta de uso da PLATAFORMA JUSLABORE como uma
          ferramenta para promover e anunciar CONTE&Uacute;DO, os
          USU&Aacute;RIOS est&atilde;o cientes e consentem que toda a
          informa&ccedil;&atilde;o relevante ser&aacute; fornecida para
          habilitar PRODUTORES e AFILIADOS a venderem seus CONTE&Uacute;DOS.
        </li>
        <li>
          a PLATAFORMA JUSLABORE tomar&aacute; todas as medidas poss&iacute;veis
          para manter a confidencialidade e a seguran&ccedil;a das
          informa&ccedil;&otilde;es dos USU&Aacute;RIOS, mas n&atilde;o
          poder&aacute; ser considerada respons&aacute;vel por perdas ou danos
          derivados da viola&ccedil;&atilde;o de tais medidas por terceiros que
          usarem redes p&uacute;blicas ou a Internet com o prop&oacute;sito de
          subverter o sistema de seguran&ccedil;a e/ou ter acesso a
          informa&ccedil;&otilde;es confidenciais de USU&Aacute;RIOS;
        </li>
        <li>
          Os USU&Aacute;RIOS, em especial PRODUTORES e AFILIADOS, dever&atilde;o
          aceitar e respeitar todas as pol&iacute;ticas da PLATAFORMA JUSLABORE,
          reconhecendo que ao se cadastrarem na PLATAFORMA JUSLABORE, tomaram
          conhecimento de tais documentos, que est&atilde;o devidamente
          publicados no site da PLATAFORMA JUSLABORE (
          <a href="http://www.hotmart.com/">juslabore.com.br</a>
          ), sujeitando-se a observar todas as regras, princ&iacute;pios e
          diretrizes neles previstos;
        </li>
        <li>
          os USU&Aacute;RIOS ser&atilde;o integralmente respons&aacute;veis por
          cumprir as leis e normativos aplic&aacute;veis relativos a
          prote&ccedil;&atilde;o de dados pessoais, em especial a Lei Geral de
          Prote&ccedil;&atilde;o de Dados Lei n&ordm; 13.709/18, assumindo a
          obriga&ccedil;&atilde;o de obter o consentimento expresso e
          inequ&iacute;voco de seus usu&aacute;rios relativamente a coleta,
          armazenamento, tratamento e processamento de dados pessoais, nos
          termos da legisla&ccedil;&atilde;o aplic&aacute;vel. Assim, a
          PLATAFORMA JUSLABORE n&atilde;o ser&aacute; responsabilizada por
          eventual falha de seus USU&Aacute;RIOS em cumprir tais normas, se
          reservando ao direito de suspender e/ou cancelar o contrato com
          USU&Aacute;RIOS que n&atilde;o estejam em conformidade com a
          legisla&ccedil;&atilde;o de prote&ccedil;&atilde;o de dados
          aplic&aacute;vel, bem como reter o saldo de valores a receber de tais
          USU&Aacute;RIOS como ressarcimento parcial dos danos que tiver
          experimentado, ou entregue a terceiros prejudicados, mediante ordem
          judicial.
        </li>
      </ol>
      <p>
        Os PRODUTORES e AFILIADOS concordam que a PLATAFORMA JUSLABORE
        poder&aacute;, a seu exclusivo crit&eacute;rio, realizar o bloqueio
        preventivo da(s) conta(s) e respectivos valores nela existentes, sempre
        que tomar conhecimento de qualquer ind&iacute;cio de ato ou conduta que
        possa caracterizar uma pr&aacute;tica ilegal, especialmente relacionados
        &agrave; pr&aacute;tica de lavagem de dinheiro, financiamento ao
        terrorismo e crimes, viola&ccedil;&atilde;o de direitos de imagem,
        propriedade intelectual e industrial, viola&ccedil;&atilde;o aos Termos
        de Uso e Pol&iacute;tica de Privacidade da PLATAFORMA JUSLABORE ou que
        represente infra&ccedil;&atilde;o &agrave; direitos de USU&Aacute;RIOS
        ou terceiros.
      </p>
      <p>
        Al&eacute;m disso, PRODUTORES e AFILIADOS concordam que a PLATAFORMA
        JUSLABORE tamb&eacute;m poder&aacute; realizar, a seu exclusivo
        crit&eacute;rio, o bloqueio preventivo da(s) conta(s) e respectivos
        valores nela existentes, caso sejam identificados par&acirc;metros e
        &iacute;ndices at&iacute;picos de reembolsos, &ldquo;chargebacks&rdquo;
        e demais &iacute;ndices operacionais que s&atilde;o objeto de
        an&aacute;lise pelas equipes de Riscos e &ldquo;Compliance&rdquo;, que
        indiquem a necessidade de efetiva&ccedil;&atilde;o do bloqueio a fim de
        resguardar direitos de USU&Aacute;RIOS, COMPRADORES e terceiros.
      </p>
      <p>
        Considerando que a PLATAFORMA JUSLABORE n&atilde;o &eacute;
        respons&aacute;vel pelo conte&uacute;do gerado pelos PRODUTORES ou
        AFILIADOS em sua PLATAFORMA, o bloqueio preventivo ser&aacute; mantido,
        em regra, at&eacute; que: (i) constate-se que o ato ou conduta suspeita
        n&atilde;o caracterizou pr&aacute;tica ilegal, com base em
        crit&eacute;rios e avalia&ccedil;&atilde;o exclusiva da PLATAFORMA
        JUSLABORE; (ii) as partes envolvidas formalizem adequadamente a
        resolu&ccedil;&atilde;o amig&aacute;vel da quest&atilde;o; ou (iii) por
        ordem judicial ou determina&ccedil;&atilde;o de autoridades
        administrativas que contenha identifica&ccedil;&atilde;o clara e
        espec&iacute;fica do conte&uacute;do ou ato apontado como infringente,
        permitindo sua adequada identifica&ccedil;&atilde;o e
        ado&ccedil;&atilde;o das medidas requeridas. Caso reste confirmado a
        natureza ilegal da conduta, o bloqueio preventivo ser&aacute; convertido
        em definitivo, sendo que os valores eventualmente existentes na conta
        apenas ser&atilde;o liberados a quem de direito e mediante ordem
        judicial.
      </p>
      <p>
        Ressalta-se que o bloqueio preventivo citado acima n&atilde;o
        caracteriza aplica&ccedil;&atilde;o de penalidade aos USU&Aacute;RIOS,
        por se tratar de uma medida cautelar adotada com o &uacute;nico objetivo
        de buscar evitar a ocorr&ecirc;ncia de danos, preju&iacute;zos ou
        infra&ccedil;&otilde;es &agrave; direitos dos USU&Aacute;RIOS e
        terceiros.
      </p>
      <p>
        Por fim, os USU&Aacute;RIOS reconhecem e autorizam que a PLATAFORMA
        JUSLABORE reporte aos &oacute;rg&atilde;os de controle e
        fiscaliza&ccedil;&atilde;o respons&aacute;veis os atos, condutas e
        pr&aacute;ticas que contenham ind&iacute;cios de irregularidades e/ou
        ilegalidades, sem que isso gere qualquer tipo de preju&iacute;zo ou dano
        moral e patrimonial ao USU&Aacute;RIO reportado.
      </p>
      <ol start="22">
        <li>
          <strong>PENALIDADES</strong>
        </li>
      </ol>
      <p>
        Qualquer conduta contr&aacute;ria ao previsto nestes Termos de Uso
        poder&aacute; ser punida:
      </p>
      <ol type='a'>
        <li>com a remo&ccedil;&atilde;o de determinado CONTE&Uacute;DO;</li>
        <li>
          com a suspens&atilde;o imediata do acesso &agrave; conta do
          USU&Aacute;RIO;
        </li>
        <li>
          com o bloqueio da conta do USU&Aacute;RIO da PLATAFORMA JUSLABORE.
        </li>
      </ol>
      <p>
        Tudo a crit&eacute;rio exclusivo da PLATAFORMA JUSLABORE, sem
        preju&iacute;zo de poderem ser tomadas as a&ccedil;&otilde;es legais
        cab&iacute;veis pela pr&oacute;pria PLATAFORMA JUSLABORE ou por
        terceiros.
      </p>
      <p>
        Nos casos de remo&ccedil;&atilde;o de CONTE&Uacute;DO,
        transa&ccedil;&otilde;es relacionadas ao CONTE&Uacute;DO removido
        realizadas anteriormente &agrave; remo&ccedil;&atilde;o poder&atilde;o
        ter seus respectivos valores bloqueados. A partir da
        remo&ccedil;&atilde;o do CONTE&Uacute;DO de uma determinada conta,
        nenhuma nova transa&ccedil;&atilde;o referente a tal CONTE&Uacute;DO
        ser&aacute; processada pelas ferramentas de pagamento da PLATAFORMA
        JUSLABORE para aquela conta.
      </p>
      <p>
        Nos casos de suspens&atilde;o do acesso &agrave; conta do
        USU&Aacute;RIO, transa&ccedil;&otilde;es relacionadas aos
        CONTE&Uacute;DOS cadastrados por aquela conta poder&atilde;o continuar a
        ser realizadas, por&eacute;m, o usu&aacute;rio n&atilde;o ter&aacute;
        acesso a qualquer funcionalidade da conta, exemplo: nenhuma
        altera&ccedil;&atilde;o poder&aacute; ser realizada nos dados
        cadastrais, dados banc&aacute;rios ou nos conte&uacute;dos cadastrados,
        tampouco poder&aacute; ser feito qualquer resgate de valores acumulados
        na respectiva conta.
      </p>
      <p>
        Nos casos de bloqueio a conta do cadastro do USU&Aacute;RIO, todos os
        an&uacute;ncios ativos e/ou ofertas realizadas ser&atilde;o
        automaticamente cancelados, n&atilde;o assistindo ao USU&Aacute;RIO, por
        essa raz&atilde;o, qualquer direito de indeniza&ccedil;&atilde;o ou
        ressarcimento.
      </p>
      <p>
        Caso a PLATAFORMA JUSLABORE suspeite ou tenha ind&iacute;cios de que o
        USU&Aacute;RIO est&aacute; usando mecanismos para fraudar o sistema de
        rastreamento de AFILIADOS OU UTILIZANDO QUALQUER OUTRO MECANISMO DE
        FRAUDE, a PLATAFORMA JUSLABORE reserva-se o direito de suspender
        imediatamente o acesso &agrave; conta do USU&Aacute;RIO suspeito de
        fraude e, eventualmente, bloquear em definitivo a conta do
        USU&Aacute;RIO, sendo certo que o saldo de valores a receber deste
        USU&Aacute;RIO poder&aacute; ser retido pela PLATAFORMA JUSLABORE, como
        ressarcimento parcial dos danos que tiver experimentado, ou entregue a
        terceiros prejudicados, mediante ordem judicial.
      </p>
      <p>
        A PLATAFORMA JUSLABORE, os USU&Aacute;RIOS ou quaisquer terceiros
        prejudicados poder&atilde;o tomar as a&ccedil;&otilde;es legais
        cab&iacute;veis em decorr&ecirc;ncia dos delitos ou
        contraven&ccedil;&otilde;es de que sejam v&iacute;timas, ou ainda buscar
        o ressarcimento pelos preju&iacute;zos civis por descumprimento dos
        Termos de Uso, sem que isso acarrete qualquer direito de
        indeniza&ccedil;&atilde;o por parte da PLATAFORMA JUSLABORE ao
        USU&Aacute;RIO acionado.
      </p>
      <ol start="23">
        <li>
          <strong>
            ISEN&Ccedil;&Atilde;O DE RESPONSABILIDADE DA PLATAFORMA JUSLABORE
          </strong>
        </li>
      </ol>
      <p>
        Nos casos em que um ou mais USU&Aacute;RIOS ou algum terceiro inicie
        qualquer tipo de disputa, reclama&ccedil;&atilde;o ou a&ccedil;&atilde;o
        legal contra outro ou outros USU&Aacute;RIOS, todos os USU&Aacute;RIOS
        envolvidos nas disputas, reclama&ccedil;&otilde;es ou
        a&ccedil;&otilde;es eximem de toda responsabilidade a PLATAFORMA
        JUSLABORE e a seus diretores, gerentes, empregados, agentes,
        oper&aacute;rios, representantes e procuradores, inclusive no que tange
        os custos e honor&aacute;rios incorridos pelos USU&Aacute;RIOS para
        promover as disputas, reclama&ccedil;&otilde;es ou a&ccedil;&otilde;es.
      </p>
      <p>
        Em termos jur&iacute;dicos, at&eacute; onde permitido por lei, a
        PLATAFORMA JUSLABORE, n&atilde;o &eacute; respons&aacute;vel por danos e
        preju&iacute;zos financeiros, materiais e morais, diretos ou indiretos,
        inclusive lucros cessantes, bem como danos f&iacute;sicos eventualmente
        sofridos pelos USU&Aacute;RIOS.
      </p>
      <ol start="24">
        <li>
          <strong>INDENIZA&Ccedil;&Atilde;O</strong>
        </li>
      </ol>
      <p>
        O USU&Aacute;RIO concorda em ressarcir a PLATAFORMA JUSLABORE, seus
        empregados, s&oacute;cios, empresas afiliadas ou subsidi&aacute;rias
        quaisquer despesas incorridas com a&ccedil;&otilde;es judiciais oriundas
        de a&ccedil;&otilde;es ou omiss&otilde;es do USU&Aacute;RIO que violem
        os presentes Termos de Uso ou as Pol&iacute;ticas da PLATAFORMA
        JUSLABORE, incluindo honor&aacute;rios advocat&iacute;cios.
      </p>
      <ol start="25">
        <li>
          <strong>RESCIS&Atilde;O</strong>
        </li>
      </ol>
      <p>
        A PLATAFORMA JUSLABORE poder&aacute; encerrar, a seu exclusivo
        crit&eacute;rio, quaisquer servi&ccedil;os oferecidos e remover
        quaisquer CONTE&Uacute;DOS nele publicados. A PLATAFORMA JUSLABORE
        poder&aacute; tamb&eacute;m restringir o acesso de USU&Aacute;RIOS a
        qualquer parte ou a todos os servi&ccedil;os oferecidos pela PLATAFORMA
        JUSLABORE a qualquer momento, com ou sem justa causa ou
        notifica&ccedil;&atilde;o pr&eacute;via, e por qualquer raz&atilde;o ou
        motivo.
      </p>
      <p>
        O PRODUTOR poder&aacute; deixar de usar a PLATAFORMA JUSLABORE a
        qualquer tempo, devendo para tanto remover todo o seu CONTE&Uacute;DO,
        bem como responsabilizar-se pela entrega de qualquer CONTE&Uacute;DO que
        tenha sido comprado atrav&eacute;s de &ldquo;links&rdquo; anteriormente
        divulgados. Al&eacute;m disso, o PRODUTOR deve realizar seu
        descadastramento como USU&Aacute;RIO da PLATAFORMA JUSLABORE. O
        PRODUTOR, entretanto, continuar&aacute; respons&aacute;vel pelo
        CONTE&Uacute;DO perante o COMPRADOR, nos termos da
        legisla&ccedil;&atilde;o aplic&aacute;vel.
      </p>
      <p>
        O AFILIADO poder&aacute; parar de promover qualquer CONTE&Uacute;DO ou
        deixar o Programa de Afiliados da PLATAFORMA JUSLABORE a qualquer tempo.
        Para tanto, o AFILIADO dever&aacute; realizar seu descadastramento como
        USU&Aacute;RIO da PLATAFORMA JUSLABORE, para que os &ldquo;links&rdquo;
        de CONTE&Uacute;DO a ele atribu&iacute;dos sejam cancelados.
      </p>
      <p>
        Caso o USU&Aacute;RIO deseje terminar sua conta, poder&aacute; apenas
        cessar seu acesso e uso dos servi&ccedil;os prestados pela PLATAFORMA
        JUSLABORE, que n&atilde;o ser&aacute; respons&aacute;vel, em qualquer
        hip&oacute;tese, por manter ou devolver o CONTE&Uacute;DO publicado, a
        conta, identifica&ccedil;&atilde;o ou senha do USU&Aacute;RIO.
      </p>
      <p>
        Em qualquer caso, inclusive de rescis&atilde;o, a PLATAFORMA JUSLABORE
        poder&aacute;, a seu exclusivo crit&eacute;rio, reter total ou
        parcialmente o saldo existente na conta do USU&Aacute;RIO, caso entenda
        que tal medida &eacute; necess&aacute;ria para garantir o pagamento,
        ressarcimento e reembolso devidos em raz&atilde;o de qualquer
        responsabilidade, obriga&ccedil;&otilde;es ou d&iacute;vida que o
        USU&Aacute;RIO possa ter incorrido com a PLATAFORMA JUSLABORE e/ou
        terceiros.
      </p>
      <p>
        O percentual de reten&ccedil;&atilde;o ser&aacute; avaliado de forma
        casu&iacute;stica, de acordo com o perfil, hist&oacute;rico de
        ocorr&ecirc;ncias, transa&ccedil;&otilde;es dos USU&Aacute;RIOS e sempre
        ser&aacute; estipulado no montante necess&aacute;rio a garantir o
        cumprimento das obriga&ccedil;&otilde;es pret&eacute;ritas e futuras
        eventualmente assumidas pelos USU&Aacute;RIOS perante a PLATAFORMA
        JUSLABORE e terceiros.
      </p>
      <ol start="26">
        <li>
          <strong>ALCANCE DOS SERVI&Ccedil;OS</strong>
        </li>
      </ol>
      <p>
        Estes Termos n&atilde;o geram nenhum contrato de sociedade, de mandato,
        parceria, franquia ou rela&ccedil;&atilde;o de trabalho entre a
        PLATAFORMA JUSLABORE e o USU&Aacute;RIO.
      </p>
      <ol start="27">
        <li>
          <strong>MODIFICA&Ccedil;&Otilde;ES NOS TERMOS DE USO</strong>
        </li>
      </ol>
      <p>
        Quando houver altera&ccedil;&atilde;o nos Termos de Uso e nas
        Pol&iacute;ticas da PLATAFORMA JUSLABORE, o USU&Aacute;RIO ser&aacute;
        comunicado por e-mail ou publica&ccedil;&atilde;o em &aacute;rea de
        destaque na PLATAFORMA JUSLABORE.
      </p>
      <p>
        Ressalta-se que o presente Termos de Uso constitui o acordo entre as
        partes a que se refere. Nesse sentido, este instrumento prevalece sobre
        todas as propostas, entendimentos anteriores e todos os acordos, orais e
        escritos, eventualmente existentes entre as partes. Assim, a PLATAFORMA
        JUSLABORE reserva-se o direito de alterar os Termos de Uso a qualquer
        momento. Ap&oacute;s a comunica&ccedil;&atilde;o referente as
        altera&ccedil;&otilde;es dos Termos de Uso, conforme procedimentos
        mencionados acima, caso o USU&Aacute;RIO de continuidade ao uso da
        PLATAFORMA JUSLABORE significar&aacute; e ser&aacute; considerada como
        seu consentimento e aceita&ccedil;&atilde;o irrevog&aacute;vel e
        irretrat&aacute;vel. Dessa forma, o USU&Aacute;RIO concorda que tem o
        encargo de rever periodicamente o site (incluir endere&ccedil;o do site)
        para se informar sobre quaisquer altera&ccedil;&otilde;es.
      </p>
      <ol start="28">
        <li>
          <strong>FORO</strong>
        </li>
      </ol>
      <p>
        Para opera&ccedil;&otilde;es realizadas a partir das ferramentas
        disponibilizadas pela PLATAFORMA JUSLABORE fica eleito o foro da Comarca
        de Mogi das Cruzes/SP como o &uacute;nico competente para dirimir
        eventuais controv&eacute;rsias referentes &agrave;
        interpreta&ccedil;&atilde;o e ao cumprimento destes Termos de Uso e
        Pol&iacute;tica de Privacidade, independentemente de outro, por mais
        privilegiado que seja.
      </p>
      <ol start="29">
        <li>
          <strong>D&Uacute;VIDAS</strong>
        </li>
      </ol>
      <p>
        Caso tenha qualquer d&uacute;vida em rela&ccedil;&atilde;o ao presente
        documento, o USU&Aacute;RIO poder&aacute; entrar em contato por meio do{' '}
        <strong>
          <span>
            <a href="mailto:juslaboretech@gmail.com">juslaboretech@gmail.com</a>
          </span>
        </strong>
        <span style={{ textDecoration: 'line-through' }}>,</span> utilizando no
        t&iacute;tulo da mensagem a frase: &ldquo;Termos de Uso&rdquo;.
      </p>
      <p>(Vers&atilde;o v.001/2019, atualizada em outubro de 2019 )</p>
      <p>Todos os direitos reservados JUSLABORE</p>

      {onClickAgreeTerms && (
        <>
          <div>
            <input type="checkbox" onChange={onClickAgreeTerms} />
            <span style={{ marginLeft: '10px' }}>
              Declaro que li e concordo com os Termos de uso da aplicação
            </span>
          </div>

          <Button
            className="self-align-end"
            onClick={closeModal}
            text="FECHAR"
            style={{
              backgroundColor: '#185335',
              marginTop: 30,
              marginRight: 15,
              float: 'right'
            }}
          />
        </>
      )}
    </div>
  );
}